import { METABOLIC_STEP_KEYS, METABOLIC_DEFAULTS, renderQuestionnaireMilestones, renderMetabolicOnboardingStep, collectMetabolicAnswers, updateMetabolicVisibility, validateMetabolicAnswers } from '../components/metabolicOnboarding.js';
import { estimateInitialExpenditure } from '../domain/metabolicEngine.js';
import { localDate } from '../domain/actionAgent.js';
import '../styles/metabolicOnboarding.css';
/**
 * NEON COACH - استبيان التخصيص الكامل (7 خطوات قابلة للاستئناف)
 * يطابق الصورتين المرجعيتين 0E211335 و A9EED71B مع رسمة القط على الميزان وحساب العمر والماكروز تلقائياً
 */

import { store } from '../state/store.js';
import { 
  calculateAge, 
  calculateNutritionTargets, 
  calculateBMR, 
  calculateTDEE, 
  calculateMaintenanceCalories,
  calculateWeightLossOption,
  calculateAllWeightLossOptions,
  WEEKLY_LOSS_OPTIONS,
  calculateWeightGainOption,
  calculateAllWeightGainOptions,
  WEEKLY_GAIN_OPTIONS,
  getRecommendedWeeklyGainRate,
  calculateWeightGainPlan,
  ACTIVITY_UI_MAP,
  kgToLbs, 
  lbsToKg,
  WEEKLY_LOSS_RATES,
  getRecommendedWeeklyLossRate,
  calculateFatLossPlan,
  evaluateWeightLossTarget
} from '../domain/calculations.js';
import { generatePersonalizedTrainingDraft, SPLIT_SCHEDULES } from '../domain/personalizedTrainingPlan.js';
import { syncService } from '../services/syncService.js';
import { authService } from '../services/authService.js';
import { notificationService } from '../services/notificationService.js';
import { neonIcon } from '../utils/neonIcons.js';
import { searchFoods } from '../data/foods.js';
import { SUPPLEMENT_DB, searchSupplementsDb } from '../data/supplementsDb.js';
import { nutritionPlanService } from '../services/nutritionPlanService.js';
import { DEFAULT_PLAN_PREFERENCES } from '../domain/nutritionPlanPolicy.js';
import { fortyDayWorkoutService } from '../services/fortyDayWorkoutService.js';
import { renderBodyFatStep, getBodyFatRange, getBodyFatRanges } from '../components/bodyFatPicker.js';
import { startBodyFatImageLoader } from '../utils/bodyFatImageLoader.js';
import '../styles/bodyFatPicker.css';
import '../styles/planPreferencesStep.css';

const QUICK_SUPPLEMENT_NAMES = [
  'Creatine monohydrate',
  'Omega-3 (Fish oil)',
  'Vitamin D3',
  'Whey protein'
];

let currentStep = 1;
let showWelcomeScreen = true;
let extremeConfirmed = false;
let extremeGainConfirmed = false;
let approvedTrainingDraft = null;

export const STEP_KEYS = {
  MEASUREMENTS: 'measurements',
  BODY_FAT: 'body_fat',
  METABOLIC_HISTORY: 'metabolic_history',
  METABOLIC_ACTIVITY: 'metabolic_activity',
  METABOLIC_STRATEGY: 'metabolic_strategy',
  GOAL: 'goal',
  WEEKLY_LOSS_RATE: 'weekly_loss_rate',
  WEEKLY_GAIN_RATE: 'weekly_gain_rate',
  NUTRITION: 'nutrition',
  PLAN_PREFERENCES: 'plan_preferences',
  PLAN_PREFERENCES_2: 'plan_preferences_2',
  HEALTH: 'health',
  TRAINING: 'training',
  SUPPLEMENTS: 'supplements',
  REVIEW: 'review'
};

export function getActiveSteps() {
  if (formData.goal === 'fat_loss') {
    return [
      STEP_KEYS.MEASUREMENTS,
      STEP_KEYS.BODY_FAT,
      STEP_KEYS.METABOLIC_ACTIVITY,
      STEP_KEYS.GOAL,
      STEP_KEYS.WEEKLY_LOSS_RATE,
      STEP_KEYS.NUTRITION,
      STEP_KEYS.PLAN_PREFERENCES,
      STEP_KEYS.PLAN_PREFERENCES_2,
      STEP_KEYS.HEALTH,
      STEP_KEYS.TRAINING,
      STEP_KEYS.METABOLIC_STRATEGY,
      STEP_KEYS.SUPPLEMENTS,
      STEP_KEYS.REVIEW
    ];
  }
  if (formData.goal === 'muscle_gain') {
    return [
      STEP_KEYS.MEASUREMENTS,
      STEP_KEYS.BODY_FAT,
      STEP_KEYS.METABOLIC_ACTIVITY,
      STEP_KEYS.GOAL,
      STEP_KEYS.WEEKLY_GAIN_RATE,
      STEP_KEYS.NUTRITION,
      STEP_KEYS.PLAN_PREFERENCES,
      STEP_KEYS.PLAN_PREFERENCES_2,
      STEP_KEYS.HEALTH,
      STEP_KEYS.TRAINING,
      STEP_KEYS.METABOLIC_STRATEGY,
      STEP_KEYS.SUPPLEMENTS,
      STEP_KEYS.REVIEW
    ];
  }
  return [
    STEP_KEYS.MEASUREMENTS,
    STEP_KEYS.BODY_FAT,
    STEP_KEYS.METABOLIC_ACTIVITY,
    STEP_KEYS.GOAL,
    STEP_KEYS.NUTRITION,
    STEP_KEYS.PLAN_PREFERENCES,
    STEP_KEYS.PLAN_PREFERENCES_2,
    STEP_KEYS.HEALTH,
    STEP_KEYS.TRAINING,
    STEP_KEYS.METABOLIC_STRATEGY,
    STEP_KEYS.SUPPLEMENTS,
    STEP_KEYS.REVIEW
  ];
}


// بيانات الاستبيان الجاري تعبئتها
let formData = {
  ...METABOLIC_DEFAULTS,
  targetMode: 'coached',
  name: '',
  age: 18, // 18 سنة افتراضياً كما طلب المستخدم
  gender: 'male',
  height: 175, // 175 سم افتراضياً كما طلب المستخدم
  weight: 70, // 70 كغ افتراضياً كما طلب المستخدم
  bodyFatRange: '',
  bodyFatPercent: null, // visual estimate, not measured body composition
  unitSystem: 'metric', // metric or imperial
  goal: 'fat_loss',
  targetWeight: 65,
  bmr: 1674,
  maintenanceCalories: 2452,
  selectedWeeklyLossRate: 0.0075,
  selectedWeeklyLossPercent: 0.0075,
  weeklyLossPercent: 0.0075,
  selectedWeeklyLossKg: 0.53,
  weeklyLossKg: 0.53,
  weeklyCalorieDeficit: 4083,
  dailyCalorieDeficit: 583,
  selectedWeeklyGainRate: 0.0050,
  selectedWeeklyGainPercent: 0.0050,
  weeklyGainPercent: 0.0050,
  selectedWeeklyGainKg: 0.35,
  weeklyGainKg: 0.35,
  weeklyCalorieSurplus: 2722,
  dailyCalorieSurplus: 389,
  requestedTargetCalories: 1869,
  requestedCalories: 1869,
  estimatedGoalWeeks: 9.4,
  weightLossRiskLevel: 'optimal',
  weightGainRiskLevel: 'optimal',
  calorieSafetyLevel: 'optimal',
  calorieWarningCodes: [],
  activityLevel: 'moderate',
  likedFoods: [],
  dislikedFoods: [],
  allergens: [],
  nutritionPlanPreferences: {
    adherence: 'high',
    mealSlots: 'breakfast_lunch_dinner',
    offPlanMealsCount: 0,
    sweets: {
      enabled: false,
      item: null,
      portion: 50,
      unit: 'غم',
      servingsPerWeek: 0
    },
    dietStyle: 'flexible',
    planFormat: 'multiple_options'
  },
  supplements: QUICK_SUPPLEMENT_NAMES.slice(0, 3),
  injuries: [],
  injuryDetails: {},
  workoutDaysCount: 4,
  equipment: 'gym',
  availableEquipment: ['machines', 'barbell', 'dumbbells', 'cables', 'bodyweight'],
  trainingLevel: 'beginner',
  trainingExperienceMonths: 0,
  trainingBreakMonths: 0,
  trainingGoal: 'hypertrophy',
  focusAreas: [],
  sessionDurationMin: 50,
  sleepHours: 7,
  benchPressRecord: '',
  squatRecord: '',
  deadliftRecord: '',
  supplementsBudget: 'medium'
};

function metabolismForForm(overrides = {}) {
  const data = { ...formData, ...overrides, currentWeight: overrides.weight ?? formData.weight };
  const initial = estimateInitialExpenditure(data);
  return { rawBmr: initial.rmr ?? calculateBMR(data.weight, data.height, data.age, data.gender),
    rawTdee: initial.tdee ?? calculateMaintenanceCalories(calculateBMR(data.weight, data.height, data.age, data.gender), data.activityLevel) };
}

/**
 * قائمة الأطعمة المقترحة والمحبوبة في العالم العربي (بروتينات، نشويات، خضار، فواكه، وسناكات صحية)
 */
export const POPULAR_ARAB_RECOMMENDED_FOODS = [
  // بروتينات ولحوم (Proteins)
  { name: 'صدر دجاج', icon: '', category: 'protein', popular: true },
  { name: 'لحم عجل قليل الدهن', icon: '', category: 'protein', popular: true },
  { name: 'سمك مشوي', icon: '', category: 'protein', popular: true },
  { name: 'بيض مسلوق', icon: '', category: 'protein', popular: true },
  { name: 'تونة بالماء', icon: '', category: 'protein', popular: true },
  { name: 'سلمون', icon: '', category: 'protein', popular: false },
  { name: 'جبنة قريش', icon: '', category: 'protein', popular: false },
  { name: 'جبنة حلوم لايت', icon: '', category: 'protein', popular: false },

  // نشويات وطاقة (Carbs)
  { name: 'أرز أبيض', icon: '', category: 'carbs', popular: true },
  { name: 'أرز بسمتي', icon: '', category: 'carbs', popular: false },
  { name: 'بطاطا مشوية', icon: '', category: 'carbs', popular: true },
  { name: 'بطاطا مسلوقة', icon: '', category: 'carbs', popular: false },
  { name: 'بطاطا حلوة', icon: '', category: 'carbs', popular: true },
  { name: 'شوفان', icon: '', category: 'carbs', popular: true },
  { name: 'خبز قمح كامل', icon: '', category: 'carbs', popular: false },
  { name: 'معكرونة مسلوقة', icon: '', category: 'carbs', popular: false },
  { name: 'برغل وفريكة', icon: '', category: 'carbs', popular: false },

  // خضروات وسلطات (Veggies)
  { name: 'خس', icon: '', category: 'veggies', popular: true },
  { name: 'خيار', icon: '', category: 'veggies', popular: true },
  { name: 'طماطم', icon: '', category: 'veggies', popular: true },
  { name: 'بروكلي', icon: '', category: 'veggies', popular: true },
  { name: 'جرجير', icon: '', category: 'veggies', popular: true },
  { name: 'سبانخ', icon: '', category: 'veggies', popular: false },
  { name: 'خضار مشكلة', icon: '', category: 'veggies', popular: false },
  { name: 'كوسا وفاصوليا', icon: '', category: 'veggies', popular: false },

  // فواكه وسناكات وصحي (Fruits & Healthy Snacks)
  { name: 'تمر', icon: '', category: 'fruits', popular: true },
  { name: 'موز', icon: '', category: 'fruits', popular: true },
  { name: 'تفاح', icon: '', category: 'fruits', popular: false },
  { name: 'فراولة', icon: '', category: 'fruits', popular: false },
  { name: 'زيت زيتون', icon: '', category: 'fruits', popular: true },
  { name: 'زبادي يوناني', icon: '', category: 'fruits', popular: true },
  { name: 'زبدة فول سوداني', icon: '', category: 'fruits', popular: false },
  { name: 'مكسرات نية', icon: '', category: 'fruits', popular: false },
  { name: 'حمص حب', icon: '', category: 'fruits', popular: false }
];

export const COMMON_DISLIKED_SUGGESTIONS = [
  { name: 'سمك ومأكولات بحرية', icon: '' },
  { name: 'تونة', icon: '' },
  { name: 'كبدة', icon: '' },
  { name: 'باذنجان', icon: '' },
  { name: 'بامية', icon: '' },
  { name: 'بروكلي', icon: '' },
  { name: 'شوفان', icon: '' },
  { name: 'بيض مسلوق', icon: '' },
  { name: 'حليب وألبان', icon: '' }
];

let activeMeasurementDrawer = 'age'; // الدرج المفتوح أولاً هو العمر مش الوزن كما طلب المستخدم
let weightUnit = 'kg'; // 'kg' or 'lb'

/**
 * دالة إنشاء HTML ملخص خطة خسارة الدهون التفاعلي المركزي
 */
function renderFatLossSummaryHTML(data) {
  const weight = Number(data.weight) || 70;
  const target = Number(data.targetWeight) || (weight - 5);
  const percent = Number(data.weeklyLossPercent) || 0.0075;
  const age = Number(data.age) || 18;
  const height = Number(data.height) || 175;
  const gender = data.gender || 'male';
  const activity = data.activityLevel || 'moderate';

  const { rawBmr, rawTdee } = metabolismForForm({ gender, age, weight, height, activityLevel: activity });

  const option = calculateWeightLossOption({
    currentWeightKg: weight,
    maintenanceCalories: rawTdee,
    weeklyRate: percent,
    sex: gender,
    age,
    targetWeightKg: target
  });

  const isTargetInvalid = target >= weight;

  return `
    <div class="neon-card" style="padding: 16px; border-radius: 16px; background: rgba(14, 22, 18, 0.7); border: 1px solid rgba(85,247,165,0.25);">
      <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px; border-bottom: 1px solid rgba(85,247,165,0.15); padding-bottom: 8px;">
        <div style="font-weight: 800; color: #FFFFFF; font-size: 0.95rem; display: flex; align-items: center; gap: 6px;">
          <span></span>
          <span>هدفك المتوقع</span>
        </div>
        <div class="badge ${option.safety.badgeClass}" style="padding: 4px 10px; border-radius: 12px; font-weight: 700; font-size: 0.75rem;">
          ${option.safety.badgeText}
        </div>
      </div>

      <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 10px; margin-bottom: 12px;">
        <div style="background: rgba(0,0,0,0.3); padding: 10px; border-radius: 12px; border: 1px solid rgba(255,255,255,0.05);">
          <div style="font-size: 0.72rem; color: #9CA3AF; margin-bottom: 2px;">سعرات الثبات المقدرة</div>
          <div style="font-size: 1.1rem; font-weight: 800; color: #55F7A5;">${Math.round(rawTdee).toLocaleString('en-US')} <span style="font-size: 0.75rem; color: #B8C0BC;">سعرة / يوم</span></div>
        </div>

        <div style="background: rgba(0,0,0,0.3); padding: 10px; border-radius: 12px; border: 1px solid rgba(255,255,255,0.05);">
          <div style="font-size: 0.72rem; color: #9CA3AF; margin-bottom: 2px;">النزول الأسبوعي المقدر</div>
          <div style="font-size: 1.1rem; font-weight: 800; color: #55F7A5;">${option.weeklyLossKgRounded.toFixed(2)} <span style="font-size: 0.75rem; color: #B8C0BC;">كغ / أسبوع</span></div>
        </div>

        <div style="background: rgba(0,0,0,0.3); padding: 10px; border-radius: 12px; border: 1px solid rgba(255,255,255,0.05);">
          <div style="font-size: 0.72rem; color: #9CA3AF; margin-bottom: 2px;">العجز اليومي المقدر</div>
          <div style="font-size: 1.1rem; font-weight: 800; color: #55F7A5;">-${option.dailyDeficitRounded} <span style="font-size: 0.75rem; color: #B8C0BC;">سعرة</span></div>
        </div>

        <div style="background: rgba(0,0,0,0.3); padding: 10px; border-radius: 12px; border: 1px solid rgba(255,255,255,0.05);">
          <div style="font-size: 0.72rem; color: #9CA3AF; margin-bottom: 2px;">السعرات اليومية المقترحة</div>
          <div style="font-size: 1.15rem; font-weight: 900; color: #FFFFFF;">${option.targetCaloriesRounded.toLocaleString('en-US')} <span style="font-size: 0.75rem; color: #B8C0BC;">سعرة</span></div>
        </div>

        <div style="background: rgba(0,0,0,0.3); padding: 10px; border-radius: 12px; border: 1px solid rgba(255,255,255,0.05); grid-column: span 2;">
          <div style="font-size: 0.72rem; color: #9CA3AF; margin-bottom: 2px;">المدة التقديرية للوصول للهدف (${target} كغ)</div>
          <div style="font-size: 1.05rem; font-weight: 800; color: ${isTargetInvalid ? '#F87171' : '#55F7A5'};">
            ${isTargetInvalid 
              ? 'تتطلب وزناً مستهدفاً أقل' 
              : `~ ${option.estimatedWeeks || '—'} <span style="font-size: 0.75rem; color: #B8C0BC;">أسبوع</span>`}
          </div>
        </div>
      </div>

      ${isTargetInvalid ? `
        <div style="background: rgba(239, 68, 68, 0.1); border: 1px solid rgba(239, 68, 68, 0.3); border-radius: 10px; padding: 8px 12px; font-size: 0.76rem; color: #FCA5A5; margin-bottom: 8px; text-align: center;">
           الوزن المستهدف (${target} كغ) يجب أن يكون أقل من وزنك الحالي (${weight} كغ) لحساب مدة الوصول.
        </div>
      ` : ''}

      ${option.safety.warningMessages.length > 0 ? `
        <div style="background: rgba(245, 158, 11, 0.09); border: 1px solid rgba(245, 158, 11, 0.25); border-radius: 10px; padding: 8px 12px; font-size: 0.76rem; color: #FBBF24; margin-bottom: 8px; line-height: 1.4;">
          ${option.safety.warningMessages.map(msg => `<div> ${msg}</div>`).join('')}
        </div>
      ` : ''}

      <div style="font-size: 0.68rem; color: #8E9892; text-align: center; margin-top: 4px;">
        المدة تقديرية وقد تختلف استجابة الجسم الفعلية.
      </div>
    </div>
  `;
}

/**
 * دالة إنشاء HTML ملخص خطة زيادة الوزن والكتلة العضلية التفاعلي المركزي
 */
function renderWeightGainSummaryHTML(data) {
  const weight = Number(data.weight) || 70;
  const target = Number(data.targetWeight) || (weight + 5);
  const percent = Number(data.weeklyGainPercent) || 0.0050;
  const age = Number(data.age) || 18;
  const height = Number(data.height) || 175;
  const gender = data.gender || 'male';
  const activity = data.activityLevel || 'moderate';

  const { rawBmr, rawTdee } = metabolismForForm({ gender, age, weight, height, activityLevel: activity });

  const option = calculateWeightGainOption({
    currentWeightKg: weight,
    maintenanceCalories: rawTdee,
    weeklyRate: percent,
    sex: gender,
    age,
    targetWeightKg: target
  });

  const isTargetInvalid = target <= weight;

  return `
    <div class="neon-card" style="padding: 16px; border-radius: 16px; background: rgba(14, 22, 18, 0.7); border: 1px solid rgba(85,247,165,0.25);">
      <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px; border-bottom: 1px solid rgba(85,247,165,0.15); padding-bottom: 8px;">
        <div style="font-weight: 800; color: #FFFFFF; font-size: 0.95rem; display: flex; align-items: center; gap: 6px;">
          <span></span>
          <span>هدفك المتوقع لبناء الكتلة</span>
        </div>
        <div class="badge ${option.safety.badgeClass}" style="padding: 4px 10px; border-radius: 12px; font-weight: 700; font-size: 0.75rem;">
          ${option.safety.badgeText}
        </div>
      </div>

      <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 10px; margin-bottom: 12px;">
        <div style="background: rgba(0,0,0,0.3); padding: 10px; border-radius: 12px; border: 1px solid rgba(255,255,255,0.05);">
          <div style="font-size: 0.72rem; color: #9CA3AF; margin-bottom: 2px;">سعرات الثبات المقدرة</div>
          <div style="font-size: 1.1rem; font-weight: 800; color: #55F7A5;">${Math.round(rawTdee).toLocaleString('en-US')} <span style="font-size: 0.75rem; color: #B8C0BC;">سعرة / يوم</span></div>
        </div>

        <div style="background: rgba(0,0,0,0.3); padding: 10px; border-radius: 12px; border: 1px solid rgba(255,255,255,0.05);">
          <div style="font-size: 0.72rem; color: #9CA3AF; margin-bottom: 2px;">الزيادة الأسبوعية المقدرة</div>
          <div style="font-size: 1.1rem; font-weight: 800; color: #55F7A5;">+${option.weeklyGainKgRounded.toFixed(2)} <span style="font-size: 0.75rem; color: #B8C0BC;">كغ / أسبوع</span></div>
        </div>

        <div style="background: rgba(0,0,0,0.3); padding: 10px; border-radius: 12px; border: 1px solid rgba(255,255,255,0.05);">
          <div style="font-size: 0.72rem; color: #9CA3AF; margin-bottom: 2px;">الفائض اليومي المقدر</div>
          <div style="font-size: 1.1rem; font-weight: 800; color: #55F7A5;">+${option.dailySurplusRounded} <span style="font-size: 0.75rem; color: #B8C0BC;">سعرة</span></div>
        </div>

        <div style="background: rgba(0,0,0,0.3); padding: 10px; border-radius: 12px; border: 1px solid rgba(255,255,255,0.05);">
          <div style="font-size: 0.72rem; color: #9CA3AF; margin-bottom: 2px;">السعرات اليومية المقترحة</div>
          <div style="font-size: 1.15rem; font-weight: 900; color: #FFFFFF;">${option.targetCaloriesRounded.toLocaleString('en-US')} <span style="font-size: 0.75rem; color: #B8C0BC;">سعرة</span></div>
        </div>

        <div style="background: rgba(0,0,0,0.3); padding: 10px; border-radius: 12px; border: 1px solid rgba(255,255,255,0.05); grid-column: span 2;">
          <div style="font-size: 0.72rem; color: #9CA3AF; margin-bottom: 2px;">المدة التقديرية للوصول للهدف (${target} كغ)</div>
          <div style="font-size: 1.05rem; font-weight: 800; color: ${isTargetInvalid ? '#F87171' : '#55F7A5'};">
            ${isTargetInvalid 
              ? 'تتطلب وزناً مستهدفاً أكبر من وزنك الحالي' 
              : `~ ${option.estimatedWeeks || '—'} <span style="font-size: 0.75rem; color: #B8C0BC;">أسبوع</span>`}
          </div>
        </div>
      </div>

      ${isTargetInvalid ? `
        <div style="background: rgba(239, 68, 68, 0.1); border: 1px solid rgba(239, 68, 68, 0.3); border-radius: 10px; padding: 8px 12px; font-size: 0.76rem; color: #FCA5A5; margin-bottom: 8px; text-align: center;">
           الوزن المستهدف (${target} كغ) يجب أن يكون أكبر من وزنك الحالي (${weight} كغ) لحساب مدة الوصول.
        </div>
      ` : ''}

      ${option.safety.warningMessages.length > 0 ? `
        <div style="background: rgba(245, 158, 11, 0.09); border: 1px solid rgba(245, 158, 11, 0.25); border-radius: 10px; padding: 8px 12px; font-size: 0.76rem; color: #FBBF24; margin-bottom: 8px; line-height: 1.4;">
          ${option.safety.warningMessages.map(msg => `<div> ${msg}</div>`).join('')}
        </div>
      ` : ''}

      <div style="font-size: 0.68rem; color: #8E9892; text-align: center; margin-top: 4px;">
        المدة تقديرية وتعتمد على الالتزام بالتدريب والتغذية لبناء كتلة عضلية نقية.
      </div>
    </div>
  `;
}



/**
 * توليد HTML شاشة الترحيب السايبر الفاخرة مع شعار نيون بالمنتصف
 */
function renderWelcomeScreenHTML() {
  return `
    <div class="welcome-screen-container" style="display: flex; flex-direction: column; align-items: center; justify-content: center; min-height: 82vh; text-align: center; padding: 10px 8px 30px; animation: welcomeFadeIn 0.45s cubic-bezier(0.16, 1, 0.3, 1);">
      <style>
        @keyframes welcomeFadeIn {
          from { opacity: 0; transform: translateY(18px) scale(0.98); }
          to { opacity: 1; transform: translateY(0) scale(1); }
        }
        @keyframes welcomeGlowPulse {
          0% { transform: scale(0.95); opacity: 0.5; }
          50% { transform: scale(1.1); opacity: 0.85; }
          100% { transform: scale(0.95); opacity: 0.5; }
        }
        @keyframes welcomeOrbitRing {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        @keyframes welcomeFloatMascot {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-7px); }
        }
      </style>

      <!-- شعار نيون في المنتصف بالنص مع هالة ضوئية وحلقات سايبر بصرية فاخرة -->
      <div class="welcome-logo-wrapper" style="position: relative; width: 146px; height: 146px; margin: 15px auto 22px; display: flex; align-items: center; justify-content: center;">
        <!-- الهالة الضوئية الخارجية المتوهجة -->
        <div style="position: absolute; inset: -24px; border-radius: 50%; background: radial-gradient(circle, rgba(85, 247, 165, 0.38) 0%, rgba(85, 247, 165, 0.1) 50%, transparent 72%); filter: blur(16px); animation: welcomeGlowPulse 3.2s infinite ease-in-out;"></div>
        
        <!-- حلقة السايبر المدارية المتقطعة -->
        <div style="position: absolute; inset: -8px; border-radius: 50%; border: 1.5px dashed rgba(85, 247, 165, 0.6); animation: welcomeOrbitRing 18s linear infinite;"></div>
        
        <!-- حلقة التوهج الداخلية الأساسية -->
        <div style="position: absolute; inset: 0; border-radius: 50%; border: 2px solid rgba(85, 247, 165, 0.75); box-shadow: 0 0 28px rgba(85, 247, 165, 0.45), inset 0 0 20px rgba(85, 247, 165, 0.25); background: radial-gradient(circle, rgba(10, 32, 22, 0.9) 0%, rgba(2, 6, 5, 0.96) 100%);"></div>

        <!-- الشعار في المنتصف بالنص -->
        <div style="position: relative; z-index: 2; width: 100px; height: 100px; display: flex; align-items: center; justify-content: center; animation: welcomeFloatMascot 4s ease-in-out infinite;">
          <img src="./icons/neon-cat-coach.svg" alt="NEON COACH" style="width: 100%; height: 100%; object-fit: contain; filter: drop-shadow(0 0 18px rgba(85, 247, 165, 0.7));" onerror="this.src='./icons/icon-192.svg'">
        </div>
      </div>

      <!-- اسم وهوية NEON COACH -->
      <h1 style="font-size: 2.3rem; font-weight: 900; letter-spacing: 2.5px; color: #55F7A5; margin: 0 0 8px; text-shadow: 0 0 26px rgba(85, 247, 165, 0.55);">
        NEON COACH
      </h1>

      <!-- زر البدء الكبير -->
      <div style="width: 100%; max-width: 440px; margin-top: 36px; display: flex; flex-direction: column; gap: 12px;">
        <button type="button" id="q-welcome-start-btn" class="btn btn-primary btn-lg btn-block" style="border-radius: 24px; font-size: 1.18rem; font-weight: 900; padding: 16px 24px; box-shadow: 0 4px 30px rgba(85, 247, 165, 0.45); display: flex; align-items: center; justify-content: center; gap: 10px; cursor: pointer; border: none; transition: transform 0.2s ease, box-shadow 0.2s ease;">
          <span>ابدأ تخصيص خطتك الآن</span>
        </button>

        <p style="font-size: 0.78rem; color: #8C9992; margin: 4px 0 0; text-align: center;">
           خطوات بسيطة لتخصيص خطتك • يمكنك تعديل أي إجابة لاحقاً
        </p>
      </div>
    </div>
  `;
}

/**
 * توليد HTML خطوات الاستبيان مع شريط التقدم وزر الرجوع
 */
function renderStepWorkflowHTML(step, totalSteps, stepKey) {
  return `
    <!-- شريط التقدم بين الخطوات -->
    <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 20px;">
      <button id="q-back-step-btn" type="button" class="btn-icon" style="width: 38px; height: 38px; cursor: pointer; visibility: visible;" aria-label="رجوع">
        ❯
      </button>
      <span id="q-step-indicator-text" style="font-weight: 800; color: #55F7A5; font-size: 0.95rem; font-family: monospace;">
        الخطوة ${step} من ${totalSteps}
      </span>
      <div style="width: 38px;"></div>
    </div>

    <div id="q-milestones-container">${renderQuestionnaireMilestones(step, totalSteps)}</div>

    <!-- مؤشرات الخطوات -->
    <div id="q-steps-bar" style="display: flex; gap: 6px; margin-bottom: 24px;">
      ${Array.from({ length: totalSteps }, (_, i) => `
        <div style="flex: 1; height: 4px; border-radius: 999px; background: ${i + 1 <= step ? '#55F7A5' : 'rgba(85, 247, 165, 0.15)'}; box-shadow: ${i + 1 === step ? '0 0 8px #55F7A5' : 'none'}; transition: all 0.3s ease;"></div>
      `).join('')}
    </div>

    <!-- محتوى الخطوة النشطة -->
    <div id="step-content-area">
      ${renderStepContent(stepKey)}
    </div>
  `;
}

export function renderQuestionnaireView() {
  const profile = store.getState()?.userProfile;
  if (profile) {
    for (const key of Object.keys(METABOLIC_DEFAULTS)) if (profile[key] !== undefined) formData[key] = profile[key];
  }
  // تحميل البيانات من الملف الشخصي الحقيقي إذا توفرت
  if (profile?.name && profile.name.trim()) {
    formData.name = profile.name;
  }
  // Restore sex before reading a previously saved visual body-fat range.
  if (profile?.gender === 'female' || profile?.gender === 'male') {
    formData.gender = profile.gender;
  }
  if (profile?.age && Number(profile.age) > 0) {
    formData.age = Number(profile.age);
  } else {
    formData.age = 18;
  }
  if (profile?.height && Number(profile.height) > 0) {
    formData.height = Number(profile.height);
  } else {
    formData.height = 175;
  }
  if (profile?.currentWeight && Number(profile.currentWeight) > 0) {
    formData.weight = Number(profile.currentWeight);
  } else {
    formData.weight = 70;
  }
  if (getBodyFatRange(profile?.bodyFatRange, formData.gender)) {
    formData.bodyFatRange = profile.bodyFatRange;
    formData.bodyFatPercent = getBodyFatRange(profile.bodyFatRange, formData.gender).estimate;
  }
  if (profile?.targetWeight && Number(profile.targetWeight) > 0) {
    formData.targetWeight = Number(profile.targetWeight);
  }
  if (profile?.weeklyLossPercent && Number(profile.weeklyLossPercent) > 0) {
    formData.weeklyLossPercent = Number(profile.weeklyLossPercent);
  }
  if (profile?.goal) {
    formData.goal = profile.goal;
  }
  if (Array.isArray(profile?.supplements)) {
    formData.supplements = [...profile.supplements];
  }

  const activeSteps = getActiveSteps();
  const totalSteps = activeSteps.length;
  if (currentStep > totalSteps) currentStep = totalSteps;
  const currentStepKey = activeSteps[currentStep - 1] || activeSteps[0];

  return `
    <div class="questionnaire-container${currentStepKey === STEP_KEYS.BODY_FAT ? ' body-fat-questionnaire' : ''}" style="min-height: 100vh; padding: 20px 16px 80px; max-width: 500px; margin: 0 auto;">
      ${showWelcomeScreen ? renderWelcomeScreenHTML() : renderStepWorkflowHTML(currentStep, totalSteps, currentStepKey)}
    </div>
  `;
}

const INJURY_REGION_LABELS = { shoulder: 'الكتف', knee: 'الركبة', lower_back: 'أسفل الظهر' };
const escapeAttr = value => String(value ?? '').replace(/[&<>'"]/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[char]));

function renderInjuryDetailFields() {
  return (formData.injuries || []).filter(region => INJURY_REGION_LABELS[region]).map(region => {
    const detail = formData.injuryDetails?.[region] || {};
    return `<section data-injury-region="${region}" style="border:1px solid rgba(85,247,165,.2);border-radius:14px;padding:14px;background:rgba(255,255,255,.02);">
      <strong style="color:#55F7A5;">تفاصيل ${INJURY_REGION_LABELS[region]}</strong>
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:9px;margin-top:10px;">
        <label style="color:#B8C0BC;font-size:.8rem;">حالة المشكلة
          <select data-injury-field="status" style="margin-top:4px;">
            <option value="">اختر حالة المشكلة...</option>
            <option value="إصابة قديمة بلا أعراض" ${detail.status === 'إصابة قديمة بلا أعراض' ? 'selected' : ''}>إصابة قديمة بلا أعراض</option>
            <option value="ألم حالي" ${detail.status === 'ألم حالي' ? 'selected' : ''}>ألم حالي</option>
            <option value="إصابة مشخصة" ${detail.status === 'إصابة مشخصة' ? 'selected' : ''}>إصابة مشخصة</option>
          </select>
        </label>
        <label style="color:#B8C0BC;font-size:.8rem;">الجهة<select data-injury-field="side" style="margin-top:4px;"><option value="unspecified">غير محدد</option><option value="right" ${detail.side === 'right' ? 'selected' : ''}>يمين</option><option value="left" ${detail.side === 'left' ? 'selected' : ''}>يسار</option><option value="both" ${detail.side === 'both' ? 'selected' : ''}>الجهتان</option></select></label>
        <label style="color:#B8C0BC;font-size:.8rem;">شدة الألم 0–10<input data-injury-field="painSeverity" type="number" min="0" max="10" value="${detail.painSeverity ?? 0}" style="margin-top:4px;"></label>
        <label style="color:#B8C0BC;font-size:.8rem;">المنع الطبي<select data-injury-field="medicalBan" style="margin-top:4px;"><option value="none">لا يوجد منع مسجل</option><option value="region" ${detail.medicalBan === 'region' ? 'selected' : ''}>منع تحميل المنطقة</option><option value="all" ${detail.medicalBan === 'all' ? 'selected' : ''}>منع التدريب كلياً</option></select></label>
      </div>
      <label style="display:block;color:#B8C0BC;font-size:.8rem;margin-top:9px;">الحركات التي تزيد الألم<input data-injury-field="triggerMovements" value="${escapeAttr(detail.triggerMovements)}" placeholder="مثال: ضغط فوق الرأس، سكوات" style="margin-top:4px;"></label>
      <label style="display:block;color:#B8C0BC;font-size:.8rem;margin-top:9px;">تعليمات المختص إن وجدت<input data-injury-field="clinicianInstructions" value="${escapeAttr(detail.clinicianInstructions)}" style="margin-top:4px;"></label>
      <div style="display:flex;flex-wrap:wrap;gap:12px;margin-top:10px;color:#fff;font-size:.82rem;">
        <label><input data-injury-field="worsening" type="checkbox" ${detail.worsening ? 'checked' : ''} style="width:auto;"> الألم يتفاقم</label>
        <label><input data-injury-field="recentUnevaluated" type="checkbox" ${detail.recentUnevaluated ? 'checked' : ''} style="width:auto;"> إصابة حديثة غير مقيّمة</label>
      </div>
    </section>`;
  }).join('');
}

function renderHorizontalPickerHTML(id, min, max, step, currentVal, unit) {
  const ticks = [];
  for (let v = min; v <= max; v += step) {
    ticks.push(v);
  }
  return `
    <div class="horizontal-picker-wrapper" id="wrapper-${id}">
      <div class="picker-edge-fade-left"></div>
      <div class="picker-edge-fade-right"></div>
      <div class="picker-center-pin"></div>
      
      <!-- إطار الكبسولة المركزية المضيء بدون أي رقم ثابت حتى لا يتداخل مع أرقام المسار -->
      <div class="picker-capsule-center">
        <span class="capsule-unit" id="capsule-unit-${id}">${unit}</span>
      </div>

      <!-- مسار الأرقام الأفقي القابل للتمرير والسحب يميناً ويساراً -->
      <div class="horizontal-scroll-track" id="track-${id}" data-id="${id}" data-unit="${unit}">
        <div class="picker-spacer"></div>
        ${ticks.map(val => {
          const isMajor = val % 5 === 0;
          const isActive = val === currentVal;
          return `
            <div class="picker-tick-item ${isMajor ? 'major' : ''} ${isActive ? 'active' : ''}" data-val="${val}">
              <div class="tick-line"></div>
              <div class="tick-number">${val}</div>
            </div>
          `;
        }).join('')}
        <div class="picker-spacer"></div>
      </div>

      <!-- أزرار التقديم والتأخير السريعة ومؤشر التمرير -->
      <div class="picker-nudge-bar">
        <button type="button" class="picker-nudge-btn picker-nudge-prev" data-target="${id}" aria-label="تقليل">❮</button>
        <span class="picker-hint-text">اسحب لليمين أو اليسار للتغيير </span>
        <button type="button" class="picker-nudge-btn picker-nudge-next" data-target="${id}" aria-label="زيادة">❯</button>
      </div>
    </div>
  `;
}


function renderStepContent(step) {
  if (METABOLIC_STEP_KEYS.includes(step)) return renderMetabolicOnboardingStep(step, formData, localDate());
  switch (step) {
    case STEP_KEYS.BODY_FAT:
      return renderBodyFatStep(formData.bodyFatRange, formData.gender);
    case STEP_KEYS.MEASUREMENTS:
    case 1:
      // الخطوة 1: قياسات الجسم بنمط iOS المرجعي مع سكرول أفقي
      return `
        <div style="text-align: center; margin-bottom: 16px;">
          <h2 style="font-size: 1.55rem; color: #55F7A5; margin-bottom: 4px; font-weight: 800;">قياسات الجسم</h2>
          <p style="font-size: 0.9rem; color: #B8C0BC;">Body Measurements لحساب احتياجك بدقة</p>
        </div>

        <!-- الاسم الشخصي -->
        <div class="neon-card" style="padding: 12px 18px; margin-bottom: 14px; display: flex; align-items: center; justify-content: space-between;">
          <span style="color: #B8C0BC; font-weight: 700; font-size: 0.95rem;">الاسم الأول</span>
          <input type="text" id="q-name" value="${formData.name}" placeholder="الاسم الأول" style="width: 170px; text-align: right; padding: 7px 12px; border-radius: 10px; background: rgba(0,0,0,0.5); border: 1px solid rgba(85,247,165,0.25); color: #fff; font-size: 0.95rem;">
        </div>

        <!-- بطاقة قياسات الجسم المدمجة بنمط iOS المرجعي -->
        <div class="measurement-card-group">
          
          <!-- 1. الجنس (Sex) -->
          <div class="measurement-row" style="cursor: default;">
            <div class="measurement-label-side">
              <div class="measurement-icon-box">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><line x1="19" y1="8" x2="19" y2="14"/><line x1="22" y1="11" x2="16" y2="11"/></svg>
              </div>
              <span class="measurement-title">الجنس (Sex)</span>
            </div>
            <div class="gender-toggle-pills">
              <button type="button" class="gender-pill-btn ${formData.gender === 'male' ? 'active' : ''}" data-gender="male">ذكر</button>
              <button type="button" class="gender-pill-btn ${formData.gender === 'female' ? 'active' : ''}" data-gender="female">أنثى</button>
            </div>
          </div>

          <!-- 2. العمر (Year of birth / Age) - افتراضي 17 -->
          <div class="measurement-row ${activeMeasurementDrawer === 'age' ? 'active' : ''}" id="row-age" data-drawer="age">
            <div class="measurement-label-side">
              <div class="measurement-icon-box">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
              </div>
              <span class="measurement-title">العمر (Age)</span>
            </div>
            <div class="measurement-value-side">
              <span class="measurement-val-text" id="row-val-age">${formData.age} سنة</span>
              <span class="measurement-chevron">❯</span>
            </div>
          </div>
          <!-- الدرج الأفقي لاختيار العمر -->
          <div class="measurement-picker-drawer ${activeMeasurementDrawer === 'age' ? 'open' : ''}" id="drawer-age">
            ${renderHorizontalPickerHTML('age', 10, 90, 1, formData.age, 'سنة')}
          </div>

          <!-- 3. الوزن (Weight) - افتراضي 70 -->
          <div class="measurement-row ${activeMeasurementDrawer === 'weight' ? 'active' : ''}" id="row-weight" data-drawer="weight">
            <div class="measurement-label-side">
              <div class="measurement-icon-box">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="5" width="20" height="14" rx="2"/><circle cx="12" cy="12" r="3"/><line x1="12" y1="9" x2="12" y2="10"/></svg>
              </div>
              <span class="measurement-title">الوزن (Weight)</span>
            </div>
            <div class="measurement-value-side">
              <div class="unit-toggle-pills" onclick="event.stopPropagation();">
                <button type="button" class="unit-pill ${weightUnit === 'kg' ? 'active' : ''}" data-unit="kg">kg</button>
                <button type="button" class="unit-pill ${weightUnit === 'lb' ? 'active' : ''}" data-unit="lb">lb</button>
              </div>
              <span class="measurement-val-text" id="row-val-weight">${formData.weight} ${weightUnit === 'kg' ? 'كغ' : 'lb'}</span>
              <span class="measurement-chevron">❯</span>
            </div>
          </div>
          <!-- الدرج الأفقي لاختيار الوزن -->
          <div class="measurement-picker-drawer ${activeMeasurementDrawer === 'weight' ? 'open' : ''}" id="drawer-weight">
            ${renderHorizontalPickerHTML('weight', weightUnit === 'kg' ? 35 : 77, weightUnit === 'kg' ? 220 : 485, 1, weightUnit === 'kg' ? formData.weight : Math.round(kgToLbs(formData.weight)), weightUnit === 'kg' ? 'كغ' : 'lb')}
          </div>

          <!-- 4. الطول (Height) - افتراضي 170 -->
          <div class="measurement-row ${activeMeasurementDrawer === 'height' ? 'active' : ''}" id="row-height" data-drawer="height">
            <div class="measurement-label-side">
              <div class="measurement-icon-box">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 3H3v18h18V3z"/><path d="M3 9h4"/><path d="M3 15h4"/><path d="M3 12h8"/><path d="M3 6h4"/><path d="M3 18h4"/></svg>
              </div>
              <span class="measurement-title">الطول (Height)</span>
            </div>
            <div class="measurement-value-side">
              <span class="measurement-val-text" id="row-val-height">${formData.height} سم</span>
              <span class="measurement-chevron">❯</span>
            </div>
          </div>
          <!-- الدرج الأفقي لاختيار الطول -->
          <div class="measurement-picker-drawer ${activeMeasurementDrawer === 'height' ? 'open' : ''}" id="drawer-height">
            ${renderHorizontalPickerHTML('height', 120, 225, 1, formData.height, 'سم')}
          </div>

        </div>

        <!-- حقول مخفية لضمان التوافق التام مع الحفظ والحسابات -->
        <input type="hidden" id="q-age" value="${formData.age}">
        <input type="hidden" id="q-gender" value="${formData.gender}">
        <input type="hidden" id="q-weight" value="${formData.weight}">
        <input type="hidden" id="q-height" value="${formData.height}">

        <!-- ملاحظة قياسات الجسم مطابقة للمرجع -->
        <p style="font-size: 0.8rem; color: #8E9892; text-align: center; margin: 16px auto 0; line-height: 1.5; max-width: 90%;">
          Your body measurements are important for accurate steps, distance, and calories tracking.
        </p>

        <button id="q-next-step-btn" class="btn btn-primary btn-lg btn-block" style="margin-top: 22px; border-radius: 22px; font-size: 1.05rem; font-weight: 800;">
          متابعة ❯
        </button>
      `;

    case STEP_KEYS.GOAL:
    case 2:
      // الخطوة 2: الهدف ونمط الحياة (الصورة A9EED71B)
      return `
        <div style="text-align: center; margin-bottom: 20px;">
          <h2 style="font-size: 1.6rem; color: #55F7A5; margin-bottom: 6px; font-weight: 800;">هدفك ونمط حياتك</h2>
          <p style="font-size: 0.95rem; color: #B8C0BC;">لننشئ خطة تناسبك وتساعدك على الاستمرارية</p>
        </div>

        <div style="font-size: 0.95rem; font-weight: 700; color: #FFFFFF; margin-bottom: 12px;">اختر هدفك الأساسي:</div>
        <div style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 10px; margin-bottom: 20px;">
          
          <div class="neon-card goal-card ${formData.goal === 'fat_loss' ? 'glow' : ''}" data-goal="fat_loss" style="padding: 16px 8px; text-align: center; cursor: pointer; border-color: ${formData.goal === 'fat_loss' ? '#55F7A5' : 'rgba(85,247,165,0.2)'};">
            <div style="margin-bottom: 6px; display: flex; justify-content: center;">${neonIcon('flame', 36)}</div>
            <div style="font-weight: 800; font-size: 0.85rem; color: #FFFFFF;">خسارة الدهون</div>
            <div style="font-size: 0.7rem; color: #B8C0BC; margin-top: 4px;">تقليل الدهون وتحسين اللياقة</div>
          </div>

          <div class="neon-card goal-card ${formData.goal === 'maintenance' ? 'glow' : ''}" data-goal="maintenance" style="padding: 16px 8px; text-align: center; cursor: pointer; border-color: ${formData.goal === 'maintenance' ? '#55F7A5' : 'rgba(85,247,165,0.2)'};">
            <div style="margin-bottom: 6px; display: flex; justify-content: center;">${neonIcon('target', 36)}</div>
            <div style="font-weight: 800; font-size: 0.85rem; color: #FFFFFF;">تثبيت الوزن</div>
            <div style="font-size: 0.7rem; color: #B8C0BC; margin-top: 4px;">الحفاظ على وزنك الحالي</div>
          </div>

          <div class="neon-card goal-card ${formData.goal === 'muscle_gain' ? 'glow' : ''}" data-goal="muscle_gain" style="padding: 16px 8px; text-align: center; cursor: pointer; border-color: ${formData.goal === 'muscle_gain' ? '#55F7A5' : 'rgba(85,247,165,0.2)'};">
            <div style="margin-bottom: 6px; display: flex; justify-content: center;">${neonIcon('dumbbell', 36)}</div>
            <div style="font-weight: 800; font-size: 0.85rem; color: #FFFFFF;">زيادة الكتلة</div>
            <div style="font-size: 0.7rem; color: #B8C0BC; margin-top: 4px;">بناء العضلات وزيادة القوة</div>
          </div>
        </div>

        <div style="display: flex; flex-direction: column; gap: 14px;">
          <div class="neon-card" style="padding: 14px 18px; display: flex; align-items: center; justify-content: space-between;">
            <span style="color: #B8C0BC; font-weight: 600;">الوزن المستهدف</span>
            <div style="display: flex; align-items: center; gap: 6px;">
              <input type="number" id="q-target-weight" value="${formData.targetWeight}" style="width: 80px; text-align: center; padding: 6px 10px; border-radius: 10px;">
              <span style="color: #55F7A5; font-weight: 700;">كغ</span>
            </div>
          </div>
        </div>

        <button id="q-next-step-btn" class="btn btn-primary btn-lg btn-block" style="margin-top: 24px; border-radius: 22px;">
          متابعة
        </button>
      `;

    case STEP_KEYS.WEEKLY_LOSS_RATE: {
      // الصفحة المخصصة والمستقلة: سرعة النزول الأسبوعي وهدفك المتوقع
      const currentWeight = Number(formData.weight) || 70;
      const currentHeight = Number(formData.height) || 175;
      const currentAge = Number(formData.age) || 18;
      const currentGender = formData.gender || 'male';
      const currentActivity = formData.activityLevel || 'moderate';

      const { rawBmr, rawTdee } = metabolismForForm({ gender: currentGender, age: currentAge, weight: currentWeight, height: currentHeight, activityLevel: currentActivity });

      const options = calculateAllWeightLossOptions({
        currentWeightKg: currentWeight,
        maintenanceCalories: rawTdee,
        sex: currentGender,
        age: currentAge,
        targetWeightKg: formData.targetWeight
      });

      return `
        <div style="text-align: center; margin-bottom: 16px;">
          <h2 style="font-size: 1.6rem; color: #55F7A5; margin-bottom: 6px; font-weight: 800;">ما سرعة النزول التي تريدها؟</h2>
          <p style="font-size: 0.95rem; color: #B8C0BC;">اختر معدل خسارة الوزن الأسبوعي كنسبة من وزن جسمك (${currentWeight} كغ)</p>
        </div>

        <!-- بطاقة سعرات الثبات و BMR العلوية البارزة -->
        <div class="neon-card maintenance-highlight-card" style="padding: 14px 16px; border-radius: 16px; margin-bottom: 18px; text-align: center;">
          <div style="font-size: 0.8rem; color: #B8C0BC; margin-bottom: 4px;">تقدير مبني على بيانات جسمك ومستوى النشاط</div>
          <div style="display: flex; justify-content: center; align-items: baseline; gap: 8px; flex-wrap: wrap;">
            <span style="font-size: 1.25rem; font-weight: 900; color: #55F7A5;"> سعرات الثبات: ${Math.round(rawTdee).toLocaleString('en-US')} سعرة / يوم</span>
            <span style="font-size: 0.88rem; color: #9CA3AF;">(BMR: ${Math.round(rawBmr).toLocaleString('en-US')} سعرة / يوم)</span>
          </div>
          <div style="font-size: 0.72rem; color: #6B7280; margin-top: 4px;">
            السعرات التي تحافظ على وزنك الحالي دون زيادة أو نقصان
          </div>
        </div>

        <!-- شبكة بطاقات المعدلات الستة الديناميكية -->
        <div class="weekly-loss-rates-grid" role="radiogroup" aria-label="معدل خسارة الوزن الأسبوعي" style="margin-bottom: 18px;">
          ${options.map(opt => {
            const isSelected = Math.abs(formData.weeklyLossPercent - opt.rate) < 0.0001;
            const isDisabled = opt.isUnder18Disabled;
            const isExtreme = opt.isExtreme;
            return `
              <div class="neon-card rate-card ${isSelected ? 'active-rate' : ''} ${isExtreme ? 'extreme-card' : ''} ${isDisabled ? 'disabled' : ''}" 
                   data-rate="${opt.rate}" 
                   data-extreme="${isExtreme}"
                   data-disabled="${isDisabled}"
                   tabindex="${isDisabled ? '-1' : '0'}"
                   role="radio"
                   aria-checked="${isSelected}"
                   aria-disabled="${isDisabled}"
                   style="padding: 14px 10px; cursor: ${isDisabled ? 'not-allowed' : 'pointer'};">
                
                ${isSelected ? `
                  <div class="rate-card-check">✓</div>
                ` : ''}

                ${opt.isRecommended ? `
                  <div style="position: absolute; top: -9px; left: 50%; transform: translateX(-50%); background: #55F7A5; color: #0D1512; font-size: 0.65rem; font-weight: 800; padding: 2px 8px; border-radius: 20px; white-space: nowrap; box-shadow: 0 0 10px rgba(85,247,165,0.4);">
                    موصى به
                  </div>
                ` : ''}

                ${isExtreme ? `
                  <div style="position: absolute; top: -9px; left: 50%; transform: translateX(-50%); background: #F59E0B; color: #000; font-size: 0.65rem; font-weight: 800; padding: 2px 8px; border-radius: 20px; white-space: nowrap;">
                    EXTREME
                  </div>
                ` : ''}

                ${isDisabled ? `
                  <div style="position: absolute; bottom: 6px; left: 50%; transform: translateX(-50%); background: rgba(239, 68, 68, 0.85); color: #FFF; font-size: 0.6rem; font-weight: 800; padding: 2px 6px; border-radius: 10px; white-space: nowrap;">
                    غير متاح دون 18 عاماً
                  </div>
                ` : ''}

                <div style="display: flex; justify-content: space-between; align-items: baseline; margin-bottom: 4px;">
                  <span style="font-weight: 800; font-size: 1.05rem; color: ${isExtreme ? '#FBBF24' : '#55F7A5'};">${opt.percentText}</span>
                  <span style="font-size: 0.76rem; font-weight: 700; color: #FFFFFF;">${opt.label}</span>
                </div>

                <div style="font-size: 0.82rem; font-weight: 700; color: #E5E7EB; margin-bottom: 2px;">
                  ~ <span class="rate-card-kg">${opt.weeklyLossKgRounded.toFixed(2)}</span> كغ / أسبوع
                </div>

                <div class="rate-card-calories">
                  ${opt.targetCaloriesRounded.toLocaleString('en-US')} <span style="font-size: 0.72rem; font-weight: 600; color: #B8C0BC;">سعرة / يوم</span>
                </div>

                <div class="rate-card-deficit">
                  عجز يومي: ≈ ${opt.dailyDeficitRounded} سعرة
                </div>

                <div style="font-size: 0.68rem; color: #9CA3AF; line-height: 1.35; margin-top: auto;">
                  ${opt.description}
                </div>
              </div>
            `;
          }).join('')}
        </div>

        <!-- مودال التأكيد لمعدل 2% EXTREME -->
        <div id="extreme-loss-modal" class="modal-overlay" style="display: none; position: fixed; inset: 0; background: rgba(0,0,0,0.85); z-index: 9999; align-items: center; justify-content: center; padding: 20px; backdrop-filter: blur(6px);">
          <div class="neon-card" style="max-width: 440px; width: 100%; border: 1.5px solid #F59E0B; box-shadow: 0 0 25px rgba(245,158,11,0.25); padding: 24px; border-radius: 20px; background: #121A16;">
            <div style="text-align: center; margin-bottom: 16px;">
              <div style="font-size: 2.2rem; margin-bottom: 6px;"></div>
              <h3 style="font-size: 1.25rem; color: #FBBF24; font-weight: 800; margin-bottom: 6px;">تأكيد هدف النزول الشديد (EXTREME)</h3>
              <p style="font-size: 0.85rem; color: #D1D5DB; line-height: 1.5;">
                لقد اخترت معدل نزول أسبوعي <strong>2.0%</strong> من وزن جسمك. هذا المعدل يمثل عجزاً حرارياً قاسياً قد يؤدي لخسارة عضلية أو بطء في الأيض ويتطلب انضباطاً ومراقبة مستمرة.
              </p>
            </div>

            <div id="extreme-modal-stats" style="background: rgba(0,0,0,0.4); border-radius: 12px; padding: 12px 14px; margin-bottom: 16px; font-size: 0.85rem; border: 1px solid rgba(245,158,11,0.2);">
              <!-- يتم ملء الإحصائيات ديناميكياً -->
            </div>

            <label style="display: flex; align-items: flex-start; gap: 10px; cursor: pointer; font-size: 0.82rem; color: #D1D5DB; margin-bottom: 20px; line-height: 1.4;">
              <input type="checkbox" id="extreme-confirm-checkbox" style="margin-top: 3px; accent-color: #55F7A5; width: 18px; height: 18px; flex-shrink: 0;">
              <span>أفهم أن هذا العجز شديد وأتحمل مسؤولية متابعة حالتي الصحية وسأقوم برفع السعرات فور الشعور بإرهاق مفرط.</span>
            </label>

            <div style="display: flex; gap: 10px;">
              <button type="button" id="extreme-cancel-btn" class="btn btn-secondary" style="flex: 1; border-radius: 14px; font-size: 0.88rem; padding: 10px;">
                اختيار معدل أقل (0.75%)
              </button>
              <button type="button" id="extreme-accept-btn" class="btn btn-primary" disabled style="flex: 1; border-radius: 14px; font-size: 0.88rem; padding: 10px; opacity: 0.5; cursor: not-allowed;">
                فهمت، متابعة
              </button>
            </div>
          </div>
        </div>

        <button id="q-next-step-btn" class="btn btn-primary btn-lg btn-block" style="margin-top: 10px; border-radius: 22px;">
          متابعة
        </button>
      `;
    }

    case STEP_KEYS.WEEKLY_GAIN_RATE: {
      // الصفحة المخصصة والمستقلة: سرعة زيادة الوزن الأسبوعي وهدفك المتوقع
      const currentWeight = Number(formData.weight) || 70;
      const currentHeight = Number(formData.height) || 175;
      const currentAge = Number(formData.age) || 18;
      const currentGender = formData.gender || 'male';
      const currentActivity = formData.activityLevel || 'moderate';

      const { rawBmr, rawTdee } = metabolismForForm({ gender: currentGender, age: currentAge, weight: currentWeight, height: currentHeight, activityLevel: currentActivity });

      const options = calculateAllWeightGainOptions({
        currentWeightKg: currentWeight,
        maintenanceCalories: rawTdee,
        sex: currentGender,
        age: currentAge,
        targetWeightKg: formData.targetWeight
      });

      return `
        <div style="text-align: center; margin-bottom: 16px;">
          <h2 style="font-size: 1.6rem; color: #55F7A5; margin-bottom: 6px; font-weight: 800;">ما سرعة زيادة الوزن التي تريدها؟</h2>
          <p style="font-size: 0.95rem; color: #B8C0BC;">اختر معدل زيادة الوزن الأسبوعي كنسبة من وزن جسمك (${currentWeight} كغ)</p>
        </div>

        <!-- بطاقة سعرات الثبات و BMR العلوية البارزة -->
        <div class="neon-card maintenance-highlight-card" style="padding: 14px 16px; border-radius: 16px; margin-bottom: 18px; text-align: center;">
          <div style="font-size: 0.8rem; color: #B8C0BC; margin-bottom: 4px;">تقدير مبني على بيانات جسمك ومستوى النشاط</div>
          <div style="display: flex; justify-content: center; align-items: baseline; gap: 8px; flex-wrap: wrap;">
            <span style="font-size: 1.25rem; font-weight: 900; color: #55F7A5;"> سعرات الثبات: ${Math.round(rawTdee).toLocaleString('en-US')} سعرة / يوم</span>
            <span style="font-size: 0.88rem; color: #9CA3AF;">(BMR: ${Math.round(rawBmr).toLocaleString('en-US')} سعرة / يوم)</span>
          </div>
          <div style="font-size: 0.72rem; color: #6B7280; margin-top: 4px;">
            السعرات التي تحافظ على وزنك الحالي — سنضيف عليها فائضاً محسوباً لبناء الكتلة العضلية
          </div>
        </div>

        <!-- شبكة بطاقات المعدلات الستة الديناميكية -->
        <div class="weekly-gain-rates-grid" role="radiogroup" aria-label="معدل زيادة الوزن الأسبوعي" style="margin-bottom: 18px;">
          ${options.map(opt => {
            const isSelected = Math.abs((formData.weeklyGainPercent || 0.0050) - opt.rate) < 0.0001;
            const isDisabled = opt.isUnder18Disabled;
            const isExtreme = opt.isExtreme;
            return `
              <div class="neon-card rate-card ${isSelected ? 'active-rate' : ''} ${isExtreme ? 'extreme-card' : ''} ${isDisabled ? 'disabled' : ''}" 
                   data-rate="${opt.rate}" 
                   data-extreme="${isExtreme}"
                   data-disabled="${isDisabled}"
                   tabindex="${isDisabled ? '-1' : '0'}"
                   role="radio"
                   aria-checked="${isSelected}"
                   aria-disabled="${isDisabled}"
                   style="padding: 14px 10px; cursor: ${isDisabled ? 'not-allowed' : 'pointer'};">
                
                ${isSelected ? `
                  <div class="rate-card-check">✓</div>
                ` : ''}

                ${opt.isRecommended ? `
                  <div style="position: absolute; top: -9px; left: 50%; transform: translateX(-50%); background: #55F7A5; color: #0D1512; font-size: 0.65rem; font-weight: 800; padding: 2px 8px; border-radius: 20px; white-space: nowrap; box-shadow: 0 0 10px rgba(85,247,165,0.4);">
                    موصى به
                  </div>
                ` : ''}

                ${isExtreme ? `
                  <div style="position: absolute; top: -9px; left: 50%; transform: translateX(-50%); background: #F59E0B; color: #000; font-size: 0.65rem; font-weight: 800; padding: 2px 8px; border-radius: 20px; white-space: nowrap;">
                    EXTREME
                  </div>
                ` : ''}

                ${isDisabled ? `
                  <div style="position: absolute; bottom: 6px; left: 50%; transform: translateX(-50%); background: rgba(239, 68, 68, 0.85); color: #FFF; font-size: 0.6rem; font-weight: 800; padding: 2px 6px; border-radius: 10px; white-space: nowrap;">
                    غير متاح دون 18 عاماً
                  </div>
                ` : ''}

                <div style="display: flex; justify-content: space-between; align-items: baseline; margin-bottom: 4px;">
                  <span style="font-weight: 800; font-size: 1.05rem; color: ${isExtreme ? '#FBBF24' : '#55F7A5'};">${opt.percentText}</span>
                  <span style="font-size: 0.76rem; font-weight: 700; color: #FFFFFF;">${opt.label}</span>
                </div>

                <div style="font-size: 0.82rem; font-weight: 700; color: #E5E7EB; margin-bottom: 2px;">
                  + <span class="rate-card-kg">${opt.weeklyGainKgRounded.toFixed(2)}</span> كغ / أسبوع
                </div>

                <div class="rate-card-calories">
                  ${opt.targetCaloriesRounded.toLocaleString('en-US')} <span style="font-size: 0.72rem; font-weight: 600; color: #B8C0BC;">سعرة / يوم</span>
                </div>

                <div class="rate-card-surplus">
                  فائض يومي: +${opt.dailySurplusRounded} سعرة
                </div>

                <div style="font-size: 0.68rem; color: #9CA3AF; line-height: 1.35; margin-top: auto;">
                  ${opt.description}
                </div>
              </div>
            `;
          }).join('')}
        </div>

        <!-- مودال التأكيد لمعدل 2% EXTREME BULK -->
        <div id="extreme-gain-modal" class="modal-overlay" style="display: none; position: fixed; inset: 0; background: rgba(0,0,0,0.85); z-index: 9999; align-items: center; justify-content: center; padding: 20px; backdrop-filter: blur(6px);">
          <div class="neon-card" style="max-width: 440px; width: 100%; border: 1.5px solid #F59E0B; box-shadow: 0 0 25px rgba(245,158,11,0.25); padding: 24px; border-radius: 20px; background: #121A16;">
            <div style="text-align: center; margin-bottom: 16px;">
              <div style="font-size: 2.2rem; margin-bottom: 6px;"></div>
              <h3 style="font-size: 1.25rem; color: #FBBF24; font-weight: 800; margin-bottom: 6px;">تأكيد هدف التضخيم الأقصى (EXTREME BULK)</h3>
              <p style="font-size: 0.85rem; color: #D1D5DB; line-height: 1.5;">
                لقد اخترت معدل زيادة أسبوعي <strong>2.0%</strong> من وزن جسمك. هذا المعدل يمثل فائضاً حرارياً هائلاً قد يؤدي لاكتساب دهون سريعة إذا لم يقترن بتدريب مقاومة مكثف وانضباط مستمر.
              </p>
            </div>

            <div id="extreme-gain-modal-stats" style="background: rgba(0,0,0,0.4); border-radius: 12px; padding: 12px 14px; margin-bottom: 16px; font-size: 0.85rem; border: 1px solid rgba(245,158,11,0.2);">
              <!-- يتم ملء الإحصائيات ديناميكياً -->
            </div>

            <label style="display: flex; align-items: flex-start; gap: 10px; cursor: pointer; font-size: 0.82rem; color: #D1D5DB; margin-bottom: 20px; line-height: 1.4;">
              <input type="checkbox" id="extreme-gain-confirm-checkbox" style="margin-top: 3px; accent-color: #55F7A5; width: 18px; height: 18px; flex-shrink: 0;">
              <span>أفهم أن هذا الفائض كبير جداً وسأقوم بتكثيف تمارين المقاومة ومراقبة نسبة الدهون.</span>
            </label>

            <div style="display: flex; gap: 10px;">
              <button type="button" id="extreme-gain-cancel-btn" class="btn btn-secondary" style="flex: 1; border-radius: 14px; font-size: 0.88rem; padding: 10px;">
                اختيار معدل معتدل (0.5%)
              </button>
              <button type="button" id="extreme-gain-accept-btn" class="btn btn-primary" disabled style="flex: 1; border-radius: 14px; font-size: 0.88rem; padding: 10px; opacity: 0.5; cursor: not-allowed;">
                فهمت، متابعة
              </button>
            </div>
          </div>
        </div>

        <button id="q-next-step-btn" class="btn btn-primary btn-lg btn-block" style="margin-top: 10px; border-radius: 22px;">
          متابعة
        </button>
      `;
    }

    case STEP_KEYS.NUTRITION:
    case 3:
      // تفضيلات التغذية والحساسيات
      return `
        <div style="text-align: center; margin-bottom: 20px;">
          <h2 style="font-size: 1.6rem; color: #55F7A5; margin-bottom: 6px; font-weight: 800;">تفضيلات التغذية</h2>
          <p style="font-size: 0.95rem; color: #B8C0BC;">نستبعد الحساسيات ونوفر وجباتك المفضلة</p>
        </div>

        <div class="form-group" style="margin-bottom: 22px;">
          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
            <label class="form-label" style="font-weight: 700; color: #55F7A5; margin: 0; display: flex; align-items: center; gap: 6px; font-size: 0.95rem;">
              <span></span>
              <span>أطعمة تحبها (اختر من المقترحات أو ابحث):</span>
            </label>
            <span class="liked-foods-count-badge" style="font-size: 0.74rem; color: #55F7A5; font-weight: 700;">
              ${formData.likedFoods.length ? `${formData.likedFoods.length} صنف مختار` : ''}
            </span>
          </div>

          <div class="food-tags-box" id="box-liked-foods">
            <div class="food-tags-wrapper" id="pills-liked-foods" style="display: flex; flex-wrap: wrap; gap: 8px; align-items: center;">
              ${formData.likedFoods.map(food => `
                <span class="food-tag-pill" data-food="${food}">
                  <span>${food}</span>
                  <span class="food-tag-remove" data-type="liked" data-food="${food}" title="حذف">×</span>
                </span>
              `).join('')}
            </div>
            <input type="text" id="q-liked-foods-input" class="food-tag-input" placeholder="${formData.likedFoods.length ? '+ أضف أكلة أخرى...' : 'اكتب أول حرف للبحث وإضافة الأكلة...'}" autocomplete="off">
            <div id="dropdown-liked-foods" class="food-autocomplete-dropdown" style="display: none;"></div>
          </div>

          <!-- اقتراحات سريعة موصى بها (الأكثر شعبية في الوطن العربي) -->
          <div class="food-recommendations-wrapper">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
              <span style="font-size: 0.78rem; color: #55F7A5; font-weight: 800; display: flex; align-items: center; gap: 5px;">
                <span></span>
                <span>أطعمة شائعة ومحبوبة (اضغط للإضافة الفورية):</span>
              </span>
            </div>

            <!-- تصنيفات الأطعمة المقترحة (3 تبويبات مدمجة ومضغوطة) -->
            <div class="food-rec-category-tabs" data-type="liked">
              <button type="button" class="rec-cat-tab active" data-cat="protein">
                <span class="tab-emoji"></span>
                <span class="tab-label">بروتينات ولحوم</span>
              </button>
              <button type="button" class="rec-cat-tab" data-cat="carbs">
                <span class="tab-emoji"></span>
                <span class="tab-label">نشويات وطاقة</span>
              </button>
              <button type="button" class="rec-cat-tab" data-cat="produce">
                <span class="tab-emoji"></span>
                <span class="tab-label">خضار وفواكه وسلطات</span>
              </button>
            </div>

            <!-- شبكة الأزرار المقترحة -->
            <div class="food-rec-chips-grid" id="liked-food-rec-chips">
              ${POPULAR_ARAB_RECOMMENDED_FOODS.map(f => {
                const isSelected = formData.likedFoods.includes(f.name);
                const isPopular = f.popular ? 'true' : 'false';
                return `
                  <button type="button" class="food-rec-chip ${isSelected ? 'selected' : ''}" data-food="${f.name}" data-category="${f.category}" data-popular="${isPopular}">
                    <span>${f.icon}</span>
                    <span>${f.name}</span>
                    <span class="chip-status">${isSelected ? '✓' : '+'}</span>
                  </button>
                `;
              }).join('')}
            </div>
          </div>
        </div>

        <div class="form-group" style="margin-bottom: 22px;">
          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
            <label class="form-label" style="font-weight: 700; color: #F87171; margin: 0; display: flex; align-items: center; gap: 6px; font-size: 0.95rem;">
              <span></span>
              <span>أطعمة لا تحبها (يتم استبعادها من خطتك):</span>
            </label>
            <span class="disliked-foods-count-badge" style="font-size: 0.74rem; color: #F87171; font-weight: 700;">
              ${formData.dislikedFoods.length ? `${formData.dislikedFoods.length} مستبعد` : ''}
            </span>
          </div>

          <div class="food-tags-box" id="box-disliked-foods">
            <div class="food-tags-wrapper" id="pills-disliked-foods" style="display: flex; flex-wrap: wrap; gap: 8px; align-items: center;">
              ${formData.dislikedFoods.map(food => `
                <span class="food-tag-pill disliked-pill" data-food="${food}">
                  <span>${food}</span>
                  <span class="food-tag-remove" data-type="disliked" data-food="${food}" title="حذف">×</span>
                </span>
              `).join('')}
            </div>
            <input type="text" id="q-disliked-foods-input" class="food-tag-input" placeholder="${formData.dislikedFoods.length ? '+ أضف أكلة أخرى...' : 'اكتب أول حرف للبحث وإضافة الأكلة...'}" autocomplete="off">
            <div id="dropdown-disliked-foods" class="food-autocomplete-dropdown" style="display: none;"></div>
          </div>

          <!-- اقتراحات استبعاد سريعة -->
          <div class="food-recommendations-wrapper" style="border-color: rgba(248,113,113,0.18);">
            <div style="font-size: 0.78rem; color: #F87171; font-weight: 800; margin-bottom: 8px; display: flex; align-items: center; gap: 5px;">
              <span></span>
              <span>استبعاد سريع لأصناف لا يفضلها البعض:</span>
            </div>
            <div class="food-rec-chips-grid" id="disliked-food-rec-chips">
              ${COMMON_DISLIKED_SUGGESTIONS.map(f => {
                const isSelected = formData.dislikedFoods.includes(f.name);
                return `
                  <button type="button" class="food-rec-chip disliked ${isSelected ? 'selected' : ''}" data-food="${f.name}">
                    <span>${f.icon}</span>
                    <span>${f.name}</span>
                    <span class="chip-status">${isSelected ? '✓' : '+'}</span>
                  </button>
                `;
              }).join('')}
            </div>
          </div>
        </div>

        <button id="q-next-step-btn" class="btn btn-primary btn-lg btn-block" style="margin-top: 24px; border-radius: 22px;">
          متابعة
        </button>
      `;

    case STEP_KEYS.PLAN_PREFERENCES: {
      const prefs = formData.nutritionPlanPreferences || DEFAULT_PLAN_PREFERENCES;
      return `
        <section class="q-plan-preferences-step" dir="rtl">
        <div class="q-plan-preferences-intro">
          <h2 style="font-size: 1.6rem; color: #55F7A5; margin-bottom: 6px; font-weight: 800;">نظامك اليومي وشكل خطتك</h2>
          <p style="font-size: 0.95rem; color: #B8C0BC;">نخصص خطتك لتناسب وتيرة يومك وأسلوب حياتك</p>
        </div>

        <!-- 2. توزيع الوجبات الرئيسية -->
        <div class="form-group q-plan-question q-plan-question-meals" style="margin-bottom: 20px;">
          <label class="form-label" style="font-weight: 800; color: #FFFFFF; font-size: 0.95rem; margin-bottom: 8px; display: block;">
            1. كيف تفضل توزيع وجباتك الرئيسية في اليوم؟
          </label>
          <div class="q-mealslots-list" style="display: flex; flex-direction: column; gap: 8px;">
            <button type="button" class="btn btn-secondary q-mealslots-btn ${prefs.mealSlots === 'breakfast_lunch_dinner' ? 'active' : ''}" data-val="breakfast_lunch_dinner" style="padding: 12px 14px; border-radius: 14px; display: flex; align-items: center; justify-content: space-between; text-align: right; border-color: ${prefs.mealSlots === 'breakfast_lunch_dinner' ? '#55F7A5' : 'rgba(85,247,165,0.2)'}; background: ${prefs.mealSlots === 'breakfast_lunch_dinner' ? 'rgba(85,247,165,0.15)' : 'rgba(255,255,255,0.02)'};">
              <div>
                <div style="font-weight: 800; font-size: 0.92rem; color: #fff;">3 وجبات رئيسية (فطور، غداء، عشاء)</div>
                <div style="font-size: 0.74rem; color: #8C9992;">النظام الكلاسيكي المتوازن للطاقة والشبع طوال اليوم</div>
              </div>
              <span style="color: ${prefs.mealSlots === 'breakfast_lunch_dinner' ? '#55F7A5' : 'transparent'}; font-size: 1.1rem; font-weight: 900;">✓</span>
            </button>
            <button type="button" class="btn btn-secondary q-mealslots-btn ${prefs.mealSlots === 'breakfast_lunch' ? 'active' : ''}" data-val="breakfast_lunch" style="padding: 12px 14px; border-radius: 14px; display: flex; align-items: center; justify-content: space-between; text-align: right; border-color: ${prefs.mealSlots === 'breakfast_lunch' ? '#55F7A5' : 'rgba(85,247,165,0.2)'}; background: ${prefs.mealSlots === 'breakfast_lunch' ? 'rgba(85,247,165,0.15)' : 'rgba(255,255,255,0.02)'};">
              <div>
                <div style="font-weight: 800; font-size: 0.92rem; color: #fff;">وجبتان (فطور وغداء - صيام مسائي)</div>
                <div style="font-size: 0.74rem; color: #8C9992;">تناول السعرات نهاراً والتوقف مبكراً في المساء</div>
              </div>
              <span style="color: ${prefs.mealSlots === 'breakfast_lunch' ? '#55F7A5' : 'transparent'}; font-size: 1.1rem; font-weight: 900;">✓</span>
            </button>
            <button type="button" class="btn btn-secondary q-mealslots-btn ${prefs.mealSlots === 'lunch_dinner' ? 'active' : ''}" data-val="lunch_dinner" style="padding: 12px 14px; border-radius: 14px; display: flex; align-items: center; justify-content: space-between; text-align: right; border-color: ${prefs.mealSlots === 'lunch_dinner' ? '#55F7A5' : 'rgba(85,247,165,0.2)'}; background: ${prefs.mealSlots === 'lunch_dinner' ? 'rgba(85,247,165,0.15)' : 'rgba(255,255,255,0.02)'};">
              <div>
                <div style="font-weight: 800; font-size: 0.92rem; color: #fff;">وجبتان (غداء وعشاء - تخطي الفطور)</div>
                <div style="font-size: 0.74rem; color: #8C9992;">مثالي للصيام المتقطع الكلاسيكي 16/8 وتأخير أول وجبة</div>
              </div>
              <span style="color: ${prefs.mealSlots === 'lunch_dinner' ? '#55F7A5' : 'transparent'}; font-size: 1.1rem; font-weight: 900;">✓</span>
            </button>
          </div>
        </div>

        <!-- 3. عدد الوجبات المفتوحة بالأسبوع -->
        <div class="form-group q-plan-question q-plan-question-offplan" style="margin-bottom: 20px;">
          <div class="q-free-meal-heading" style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
            <label class="form-label" style="font-weight: 800; color: #FFFFFF; font-size: 0.95rem; margin: 0;">
              2. كم وجبة مفتوحة (Free Meal) تريد في الأسبوع؟
            </label>
            <span id="offplan-count-badge" style="font-size: 0.88rem; font-weight: 900; color: #55F7A5; font-family: monospace;">
              ${prefs.offPlanMealsCount} ${prefs.offPlanMealsCount === 0 ? '(بدون وجبات مفتوحة)' : 'وجبة أسبوعياً'}
            </span>
          </div>
          <div class="q-offplan-grid" style="display: flex; gap: 6px; overflow-x: auto; padding-bottom: 4px;">
            ${[0, 1, 2, 3, 4, 5, 6, 7].map(num => `
              <button type="button" class="btn btn-secondary q-offplan-chip ${prefs.offPlanMealsCount === num ? 'active' : ''}" data-val="${num}" style="flex: 1; min-width: 36px; height: 42px; border-radius: 12px; font-weight: 800; font-family: monospace; font-size: 1rem; border-color: ${prefs.offPlanMealsCount === num ? '#55F7A5' : 'rgba(85,247,165,0.2)'}; background: ${prefs.offPlanMealsCount === num ? 'rgba(85,247,165,0.2)' : 'rgba(255,255,255,0.02)'}; color: ${prefs.offPlanMealsCount === num ? '#55F7A5' : '#fff'};">
                ${num}
              </button>
            `).join('')}
          </div>
          <small style="color: #8C9992; font-size: 0.74rem; display: block; margin-top: 4px;">
            الوجبة المفتوحة تتيح لك تناول ما تحب بحرية واعتدال مع الحفاظ على التوازن الكلي.
          </small>
        </div>

        <!-- 4. تناول الحلويات والسكريات -->
        <div class="form-group q-plan-question q-plan-question-sweets" style="margin-bottom: 20px;">
          <div class="q-sweets-heading" style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
            <label class="form-label" style="font-weight: 800; color: #FFFFFF; font-size: 0.95rem; margin: 0;">
              3. هل تتناول حلويات أو سكريات وتريد إدراجها؟
            </label>
            <div class="q-sweets-toggle" style="display: flex; gap: 6px;">
              <button type="button" id="q-sweets-toggle-no" class="btn btn-secondary ${!prefs.sweets.enabled ? 'active' : ''}" style="padding: 4px 14px; font-size: 0.8rem; border-radius: 10px; border-color: ${!prefs.sweets.enabled ? '#55F7A5' : 'rgba(85,247,165,0.2)'}; background: ${!prefs.sweets.enabled ? 'rgba(85,247,165,0.15)' : 'transparent'}; color: #fff;">لا</button>
              <button type="button" id="q-sweets-toggle-yes" class="btn btn-secondary ${prefs.sweets.enabled ? 'active' : ''}" style="padding: 4px 14px; font-size: 0.8rem; border-radius: 10px; border-color: ${prefs.sweets.enabled ? '#55F7A5' : 'rgba(85,247,165,0.2)'}; background: ${prefs.sweets.enabled ? 'rgba(85,247,165,0.15)' : 'transparent'}; color: #fff;">نعم 🍰</button>
            </div>
          </div>

          <div id="q-sweets-details-panel" style="display: ${prefs.sweets.enabled ? 'block' : 'none'}; background: rgba(85,247,165,0.04); border: 1px solid rgba(85,247,165,0.2); border-radius: 16px; padding: 14px; margin-top: 10px;">
            <div style="margin-bottom: 10px;">
              <label style="font-size: 0.8rem; color: #B8C0BC; display: block; margin-bottom: 4px;">ابحث عن صنف الحلى المفضل:</label>
              <div style="position: relative;">
                <input type="text" id="q-sweets-search-input" value="${prefs.sweets.item ? (prefs.sweets.item.nameAr || prefs.sweets.item.name) : ''}" placeholder="اكتب للبحث (كنافة، شوكولاتة، كيك، معمول...)" class="food-tag-input" style="width: 100%; border-radius: 10px; padding: 8px 12px; background: rgba(0,0,0,0.6); border: 1px solid rgba(85,247,165,0.3); color: #fff;" autocomplete="off">
                <div id="q-sweets-dropdown" class="food-autocomplete-dropdown" style="display: none; position: absolute; z-index: 50; width: 100%; max-height: 180px; overflow-y: auto; background: #07150E; border: 1px solid #55F7A5; border-radius: 10px;"></div>
              </div>
              ${prefs.sweets.item ? `
                <div id="q-sweets-selected-badge" style="margin-top: 6px; display: inline-flex; align-items: center; gap: 6px; padding: 4px 10px; border-radius: 8px; background: rgba(85,247,165,0.12); border: 1px solid #55F7A5; color: #55F7A5; font-size: 0.82rem; font-weight: 700;">
                  <span>✓ تم اختيار: ${prefs.sweets.item.nameAr || prefs.sweets.item.name} (~${prefs.sweets.item.caloriesPer100g || prefs.sweets.item.calories || 350} سعرة/100غ)</span>
                </div>
              ` : ''}
            </div>

            <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px;">
              <div>
                <label style="font-size: 0.8rem; color: #B8C0BC; display: block; margin-bottom: 4px;">حجم الحصة (${prefs.sweets.unit || 'غم'}):</label>
                <input type="number" id="q-sweets-portion" value="${prefs.sweets.portion || 50}" min="5" max="500" step="5" style="width: 100%; padding: 8px; border-radius: 10px; text-align: center; background: rgba(0,0,0,0.6); border: 1px solid rgba(85,247,165,0.3); color: #fff; font-family: monospace;">
              </div>
              <div>
                <label style="font-size: 0.8rem; color: #B8C0BC; display: block; margin-bottom: 4px;">كم مرة في الأسبوع:</label>
                <select id="q-sweets-frequency" style="width: 100%; padding: 8px; border-radius: 10px; background: rgba(0,0,0,0.6); border: 1px solid rgba(85,247,165,0.3); color: #fff; text-align: center;">
                  ${[1, 2, 3, 4, 5, 6, 7].map(n => `<option value="${n}" ${prefs.sweets.servingsPerWeek === n ? 'selected' : ''}>${n} مرات أسبوعياً</option>`).join('')}
                </select>
              </div>
            </div>
            <div style="margin-top: 10px; font-size: 0.76rem; color: #55F7A5; font-weight: 700;">
              💡 يتم حسم سعرات الحصة تلقائياً وتوزيعها على مدار الأسبوع دون الإخلال بهدفك الأساسي.
            </div>
          </div>
        </div>

        <!-- 5. نمط الدايت -->
        <div class="form-group" style="display: none;"></div>
        <!-- 6. شكل الخطة -->
        <div class="form-group" style="display: none;"></div>

        <button id="q-next-step-btn" class="btn btn-primary btn-lg btn-block" style="margin-top: 24px; border-radius: 22px;">
          متابعة
        </button>
        </section>
      `;
    }

    case STEP_KEYS.PLAN_PREFERENCES_2: {
      const prefs = formData.nutritionPlanPreferences || DEFAULT_PLAN_PREFERENCES;
      return `
        <div style="text-align: center; margin-bottom: 20px;">
          <h2 style="font-size: 1.6rem; color: #55F7A5; margin-bottom: 6px; font-weight: 800;">أسلوب خطتك الغذائية</h2>
          <p style="font-size: 0.95rem; color: #B8C0BC;">اختر النمط الذي يناسب شخصيتك وأسلوبك</p>
        </div>

        <!-- 5. نمط الدايت -->
        <div class="form-group" style="margin-bottom: 28px;">
          <label class="form-label" style="font-weight: 800; color: #FFFFFF; font-size: 0.95rem; margin-bottom: 12px; display: block;">
            4. كيف تفضل تنوّع الوجبات؟
          </label>
          <div style="display: flex; gap: 12px; flex-wrap: wrap;">
            <button type="button" class="btn btn-secondary q-dietstyle-btn ${prefs.dietStyle === 'flexible' ? 'active' : ''}" data-val="flexible"
              style="flex: 1; min-width: 140px; padding: 20px 14px; border-radius: 18px; text-align: center; display: flex; flex-direction: column; align-items: center; gap: 8px; border-color: ${prefs.dietStyle === 'flexible' ? '#55F7A5' : 'rgba(85,247,165,0.2)'}; background: ${prefs.dietStyle === 'flexible' ? 'rgba(85,247,165,0.15)' : 'rgba(255,255,255,0.02)'}; overflow: hidden; word-break: break-word; min-width: 0;">
              <div style="font-size: 2rem; line-height: 1;">🥗</div>
              <div style="font-weight: 800; font-size: 1rem; color: ${prefs.dietStyle === 'flexible' ? '#55F7A5' : '#fff'}; white-space: nowrap;">وجبات متنوّعة</div>
              <div style="font-size: 0.78rem; color: #8C9992; line-height: 1.4; text-align: center; overflow-wrap: break-word; white-space: normal;">تنوع يومي واسع في الوجبات لمنع الملل</div>
            </button>
            <button type="button" class="btn btn-secondary q-dietstyle-btn ${prefs.dietStyle === 'strict' ? 'active' : ''}" data-val="strict"
              style="flex: 1; min-width: 140px; padding: 20px 14px; border-radius: 18px; text-align: center; display: flex; flex-direction: column; align-items: center; gap: 8px; border-color: ${prefs.dietStyle === 'strict' ? '#55F7A5' : 'rgba(85,247,165,0.2)'}; background: ${prefs.dietStyle === 'strict' ? 'rgba(85,247,165,0.15)' : 'rgba(255,255,255,0.02)'}; overflow: hidden; word-break: break-word; min-width: 0;">
              <div style="font-size: 2rem; line-height: 1;">⚡</div>
              <div style="font-weight: 800; font-size: 1rem; color: ${prefs.dietStyle === 'strict' ? '#55F7A5' : '#fff'}; white-space: nowrap;">وجبات متكررة</div>
              <div style="font-size: 0.78rem; color: #8C9992; line-height: 1.4; text-align: center; overflow-wrap: break-word; white-space: normal;">وجبات ثابتة لتسهيل التحضير والانضباط</div>
            </button>
          </div>
        </div>

        <!-- 6. شكل الخطة -->
        <div class="form-group" style="margin-bottom: 28px;">
          <label class="form-label" style="font-weight: 800; color: #FFFFFF; font-size: 0.95rem; margin-bottom: 12px; display: block;">
            5. كيف تريد شكل وتنسيق وجباتك اليومية؟
          </label>
          <div style="display: flex; gap: 12px; flex-wrap: wrap;">
            <button type="button" class="btn btn-secondary q-planformat-btn ${prefs.planFormat === 'multiple_options' ? 'active' : ''}" data-val="multiple_options"
              style="flex: 1; min-width: 140px; padding: 20px 14px; border-radius: 18px; text-align: center; display: flex; flex-direction: column; align-items: center; gap: 8px; border-color: ${prefs.planFormat === 'multiple_options' ? '#55F7A5' : 'rgba(85,247,165,0.2)'}; background: ${prefs.planFormat === 'multiple_options' ? 'rgba(85,247,165,0.15)' : 'rgba(255,255,255,0.02)'}; overflow: hidden; min-width: 0;">
              <div style="font-size: 2rem; line-height: 1;">📋</div>
              <div style="font-weight: 800; font-size: 1rem; color: ${prefs.planFormat === 'multiple_options' ? '#55F7A5' : '#fff'}; white-space: nowrap;">خيارات متعددة</div>
              <div style="font-size: 0.78rem; color: #8C9992; line-height: 1.4; text-align: center; overflow-wrap: break-word; white-space: normal;">2-3 بدائل محسوبة لكل وجبة بمرونة</div>
            </button>
            <button type="button" class="btn btn-secondary q-planformat-btn ${prefs.planFormat === 'fixed' ? 'active' : ''}" data-val="fixed"
              style="flex: 1; min-width: 140px; padding: 20px 14px; border-radius: 18px; text-align: center; display: flex; flex-direction: column; align-items: center; gap: 8px; border-color: ${prefs.planFormat === 'fixed' ? '#55F7A5' : 'rgba(85,247,165,0.2)'}; background: ${prefs.planFormat === 'fixed' ? 'rgba(85,247,165,0.15)' : 'rgba(255,255,255,0.02)'}; overflow: hidden; min-width: 0;">
              <div style="font-size: 2rem; line-height: 1;">🎯</div>
              <div style="font-weight: 800; font-size: 1rem; color: ${prefs.planFormat === 'fixed' ? '#55F7A5' : '#fff'}; white-space: nowrap;">خيار واحد محدد</div>
              <div style="font-size: 0.78rem; color: #8C9992; line-height: 1.4; text-align: center; overflow-wrap: break-word; white-space: normal;">وجبة محددة مباشرة بدون حيرة</div>
            </button>
          </div>
        </div>

        <button id="q-next-step-btn" class="btn btn-primary btn-lg btn-block" style="margin-top: 24px; border-radius: 22px;">
          متابعة
        </button>
      `;
    }

    case STEP_KEYS.HEALTH:
    case 4:
      // الصحة ونمط الحياة والنوم
      return `
        <div style="text-align: center; margin-bottom: 20px;">
          <h2 style="font-size: 1.6rem; color: #55F7A5; margin-bottom: 6px; font-weight: 800;">الإصابات وقيود التدريب</h2>
          <p style="font-size: 0.95rem; color: #B8C0BC;">نعدّل التمارين حسب الإصابات والحركات التي تسبب الألم</p>
        </div>

        <div class="neon-card" style="padding: 16px 18px; margin-bottom: 14px;">
          <div style="font-weight:800;color:#fff;margin-bottom:6px;">هل لديك إصابة أو ألم يؤثر على التدريب؟</div>
          <p style="color:#8C9992;font-size:.82rem;margin:0 0 12px;">اختر كل المناطق المتأثرة. هذه المعلومات لتعديل الخطة وليست تشخيصاً طبياً.</p>
          <div style="display:flex;flex-wrap:wrap;gap:8px;">
            ${[['none','لا يوجد'],['shoulder','الكتف'],['knee','الركبة'],['lower_back','أسفل الظهر']].map(([value,label]) => `
              <label class="badge badge-neon" style="cursor:pointer;padding:8px 14px;">
                <input type="checkbox" name="q-injuries" value="${value}" ${(value === 'none' ? formData.injuries.length === 0 : formData.injuries.includes(value)) ? 'checked' : ''} style="width:auto;margin-inline-end:6px;">
                ${label}
              </label>
            `).join('')}
          </div>
          <div id="q-injury-details" style="margin-top:14px;display:grid;gap:12px;">${renderInjuryDetailFields()}</div>
        </div>

        <button id="q-next-step-btn" class="btn btn-primary btn-lg btn-block" style="margin-top: 24px; border-radius: 22px;">
          متابعة
        </button>
      `;

    case STEP_KEYS.TRAINING:
    case 5:
      // التدريب والأيام والمعدات
      return `
        <div style="text-align: center; margin-bottom: 20px;">
          <h2 style="font-size: 1.6rem; color: #55F7A5; margin-bottom: 6px; font-weight: 800;">أيام ومكان التدريب</h2>
          <p style="font-size: 0.95rem; color: #B8C0BC;">نصمم البرنامج بعدد الأيام الفعلي (1 - 6 أيام)</p>
        </div>

        <div class="neon-card" style="padding:16px 18px;margin-bottom:14px;">
          <div style="font-weight:800;color:#fff;margin-bottom:10px;">مستواك التدريبي الذي تختاره</div>
          <div style="display:grid;grid-template-columns:repeat(3,1fr);gap:8px;">
            ${[['beginner','مبتدئ','تعلّم الحركة وحجم محافظ'],['intermediate','متوسط','خبرة منتظمة وتدرّج'],['advanced','متقدم','خبرة قوية وتحكم بالحمل']].map(([value,label,note]) => `<label style="border:1px solid ${formData.trainingLevel === value ? '#55F7A5' : 'rgba(85,247,165,.18)'};background:${formData.trainingLevel === value ? 'rgba(85,247,165,.12)' : 'rgba(255,255,255,.02)'};padding:12px 8px;border-radius:14px;text-align:center;cursor:pointer;"><input type="radio" name="q-training-level" value="${value}" ${formData.trainingLevel === value ? 'checked' : ''} style="width:auto;"><strong style="display:block;color:#fff;margin-top:5px;">${label}</strong><small style="color:#8C9992;">${note}</small></label>`).join('')}
          </div>
          <div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-top:12px;">
            <label style="color:#B8C0BC;font-size:.82rem;">أشهر الانقطاع<input id="q-training-break" type="number" min="0" max="120" value="${formData.trainingBreakMonths}" style="margin-top:5px;"></label>
          </div>
          <p style="color:#8C9992;font-size:.78rem;margin:10px 0 0;">نحفظ المستوى الذي اخترته كما هو، وقد نقترح بداية محافظة منفصلة عند العودة بعد انقطاع.</p>
        </div>

        <div class="neon-card" style="padding: 16px 18px; margin-bottom: 14px; display: flex; align-items: center; justify-content: space-between;">
          <div>
            <div style="font-weight: 700; color: #FFFFFF;">عدد أيام التمرين بالأسبوع</div>
            <div style="font-size: 0.8rem; color: #B8C0BC;">اختر من 1 إلى 6 أيام</div>
          </div>
          <select id="q-workout-days" style="width: 110px; padding: 8px; border-radius: 10px; text-align: center;">
            ${[1, 2, 3, 4, 5, 6].map(d => `<option value="${d}" ${d === formData.workoutDaysCount ? 'selected' : ''}>${d} أيام</option>`).join('')}
          </select>
        </div>

        <div class="neon-card" style="padding:16px 18px;margin-bottom:14px;">
          <div style="font-weight:800;color:#fff;margin-bottom:10px;">المعدات المتاحة فعلياً</div>
          <div style="display:flex;flex-wrap:wrap;gap:8px;">
            ${[['machines','أجهزة'],['barbell','بار وأوزان'],['dumbbells','دمبل'],['cables','كيبل'],['bands','حبال مقاومة'],['bodyweight','وزن الجسم']].map(([value,label]) => `<label class="badge badge-neon" style="cursor:pointer;padding:8px 12px;"><input type="checkbox" name="q-available-equipment" value="${value}" ${formData.availableEquipment.includes(value) ? 'checked' : ''} style="width:auto;margin-inline-end:5px;">${label}</label>`).join('')}
          </div>
        </div>

        <div class="neon-card" style="padding:16px 18px;margin-bottom:14px;">
          <div style="font-weight:800;color:#fff;margin-bottom:10px;">أولوية عضلية اختيارية</div>
          <div style="display:flex;flex-wrap:wrap;gap:8px;">
            ${[['chest','صدر'],['back','ظهر'],['legs','أرجل'],['shoulders','أكتاف'],['biceps','بايسبس'],['triceps','ترايسبس'],['abs','بطن']].map(([value,label]) => `<label class="badge badge-neon" style="cursor:pointer;padding:8px 12px;"><input type="checkbox" name="q-focus-areas" value="${value}" ${formData.focusAreas.includes(value) ? 'checked' : ''} style="width:auto;margin-inline-end:5px;">${label}</label>`).join('')}
          </div>
        </div>

        <div class="neon-card" style="padding: 16px 18px; margin-bottom: 14px; display: flex; align-items: center; justify-content: space-between;">
          <span style="font-weight: 700; color: #FFFFFF;">مدة الجلسة المناسبة</span>
          <select id="q-session-duration" style="width: 140px; padding: 8px; border-radius: 10px;">
            <option value="40" ${formData.sessionDurationMin === 40 ? 'selected' : ''}>35 - 45 دقيقة</option>
            <option value="50" ${formData.sessionDurationMin === 50 ? 'selected' : ''}>45 - 60 دقيقة</option>
            <option value="75" ${formData.sessionDurationMin === 75 ? 'selected' : ''}>60 - 75 دقيقة</option>
          </select>
        </div>

        <button id="q-next-step-btn" class="btn btn-primary btn-lg btn-block" style="margin-top: 24px; border-radius: 22px;">
          متابعة
        </button>
      `;

    case STEP_KEYS.SUPPLEMENTS:
    case 6:
      // المكملات وخط البداية
      return `
        <div style="text-align: center; margin-bottom: 20px;">
          <h2 style="font-size: 1.6rem; color: #55F7A5; margin-bottom: 6px; font-weight: 800;">المكملات وخط البداية</h2>
          <p style="font-size: 0.95rem; color: #B8C0BC;">المكملات اختيارية ومكملة للتغذية الصحية وليست أساساً</p>
        </div>

        <div class="neon-card" style="padding: 16px 18px; margin-bottom: 14px;">
          <div style="display:flex;justify-content:space-between;gap:10px;align-items:center;margin-bottom:10px;">
            <div style="font-weight: 700; color: #FFFFFF;">المكملات التي تستخدمها حالياً:</div>
            <span class="supplements-count-badge" style="color:#55F7A5;font-size:.82rem;"></span>
          </div>
          <div id="box-selected-supplements" class="food-tags-box supplement-tags-box">
            <div id="pills-selected-supplements" class="food-tags-pills"></div>
            <input id="q-supplements-input" class="food-tag-input" autocomplete="off" placeholder="اكتب أول حرف للبحث وإضافة المكمل..." aria-label="ابحث عن مكمل">
            <div id="dropdown-supplements" class="food-autocomplete-dropdown" style="display:none;"></div>
          </div>
          <div class="food-recommendations-wrapper" style="margin-top:14px;">
            <div style="font-weight:700;color:#55F7A5;margin-bottom:10px;">اختيارات شائعة (اضغط للإضافة الفورية):</div>
            <div id="supplement-rec-chips" class="food-rec-chips-grid">
              ${QUICK_SUPPLEMENT_NAMES.map(name => {
                const supplement = SUPPLEMENT_DB.find(item => item.name === name);
                return `<button type="button" class="food-rec-chip supplement-rec-chip" data-supplement="${name}">
                  <span class="chip-status">+</span><span>${supplement?.nameAr || name}</span>
                </button>`;
              }).join('')}
            </div>
          </div>
        </div>

        <button id="q-next-step-btn" class="btn btn-primary btn-lg btn-block" style="margin-top: 24px; border-radius: 22px;">
          مراجعة بياناتي
        </button>
      `;

    case STEP_KEYS.REVIEW:
    case 7:
    case 8:
      // الخطوة 7: المراجعة النهائية وزر إنشاء الخطة
      const targets = calculateNutritionTargets(formData);
      const goalNames = {
        fat_loss: `خسارة دهون (عجز ${Math.max(0, Math.round(targets.tdee - targets.targetCalories))} سعرة)`,
        maintenance: 'تثبيت الوزن (سعرات المحافظة)',
        muscle_gain: `زيادة الكتلة العضلية (فائض ${Math.max(0, Math.round(targets.targetCalories - targets.tdee))} سعرة)`
      };
      const goalText = goalNames[formData.goal] || 'خسارة دهون';
      const eqText = formData.equipment === 'home' ? 'منزل بأوزان خفيفة' : 'صالة جيم';

      return `
        <div style="text-align: center; margin-bottom: 20px;">
          <h2 style="font-size: 1.6rem; color: #55F7A5; margin-bottom: 6px; font-weight: 800;">مراجعة خطتك الشخصية</h2>
          <p style="font-size: 0.95rem; color: #B8C0BC;">راجع أهدافك قبل إنشاء وتفعيل خطة النيون</p>
        </div>

        <div class="neon-card" style="padding: 20px; margin-bottom: 16px;">
          <div style="display: flex; justify-content: space-between; border-bottom: 1px solid rgba(85,247,165,0.2); padding-bottom: 10px; margin-bottom: 12px;">
            <span style="color: #B8C0BC;">المتدرب</span>
            <span style="font-weight: 800; color: #FFFFFF;">${formData.name} (${formData.age} سنة)</span>
          </div>

          ${targets.floorApplied ? '<p style="color:#ffce85;margin-bottom:12px">تم تطبيق الحد الأدنى للسعرات؛ معدل النزول المختار يبقى هدفًا مطلوبًا وليس نتيجة مضمونة بهذه الميزانية.</p>' : ''}
          <div style="display:grid;gap:8px;margin-bottom:16px;color:#B8C0BC">
            <span>مصدر RMR: ${targets.rmrMethod} · TDEE أولي: ${targets.tdee} سعرة/يوم</span>
            <span>النظام: ${formData.macroStyle || 'standard'} · تدريب التغذية: ${formData.programTrainingType || 'غير محدد'} · البروتين: ${formData.proteinPreference || 'متوسط'}</span>
            <span>توزيع الأسبوع: ${formData.calorieDistribution === 'shift' ? 'أعلى بأيام التدريب' : 'متساوٍ'} · الميزانية: ${targets.targetCalories * 7} سعرة</span>
          </div>
          ${formData.bodyFatRange ? `<div style="display: flex; justify-content: space-between; border-bottom: 1px solid rgba(85,247,165,0.2); padding-bottom: 10px; margin-bottom: 12px;">
            <span style="color: #B8C0BC;">نسبة الدهون (تقدير بصري)</span>
            <span style="font-weight: 800; color: #55F7A5;" dir="ltr">${formData.bodyFatRange}</span>
          </div>` : ''}

          <div style="display: flex; justify-content: space-between; border-bottom: 1px solid rgba(85,247,165,0.2); padding-bottom: 10px; margin-bottom: 12px;">
            <span style="color: #B8C0BC;">الهدف الأساسي</span>
            <span style="font-weight: 800; color: #55F7A5;">${goalText}</span>
          </div>

          ${formData.goal === 'fat_loss' ? `
            <div style="display: flex; justify-content: space-between; border-bottom: 1px solid rgba(85,247,165,0.2); padding-bottom: 10px; margin-bottom: 12px;">
              <span style="color: #B8C0BC;">معدل النزول الأسبوعي</span>
              <span style="font-weight: 800; color: #55F7A5;">${(formData.weeklyLossPercent * 100).toFixed(2)}% (~${formData.weeklyLossKg} كغ/أسبوع)</span>
            </div>
            ${formData.estimatedGoalWeeks && !targets.floorApplied && !targets.goalReached ? `
              <div style="display: flex; justify-content: space-between; border-bottom: 1px solid rgba(85,247,165,0.2); padding-bottom: 10px; margin-bottom: 12px;">
                <span style="color: #B8C0BC;">المدة التقديرية للهدف</span>
                <span style="font-weight: 800; color: #FFFFFF;">حوالي ${formData.estimatedGoalWeeks} أسبوع</span>
              </div>
            ` : ''}
          ` : ''}

          ${formData.goal === 'muscle_gain' ? `
            <div style="display: flex; justify-content: space-between; border-bottom: 1px solid rgba(85,247,165,0.2); padding-bottom: 10px; margin-bottom: 12px;">
              <span style="color: #B8C0BC;">معدل الزيادة الأسبوعية</span>
              <span style="font-weight: 800; color: #55F7A5;">${((formData.weeklyGainPercent || 0.0050) * 100).toFixed(2)}% (~${formData.weeklyGainKg || 0.35} كغ/أسبوع)</span>
            </div>
            ${formData.estimatedGoalWeeks && !targets.floorApplied && !targets.goalReached ? `
              <div style="display: flex; justify-content: space-between; border-bottom: 1px solid rgba(85,247,165,0.2); padding-bottom: 10px; margin-bottom: 12px;">
                <span style="color: #B8C0BC;">المدة التقديرية للهدف</span>
                <span style="font-weight: 800; color: #FFFFFF;">حوالي ${formData.estimatedGoalWeeks} أسبوع</span>
              </div>
            ` : ''}
          ` : ''}

          <div style="display: flex; justify-content: space-between; border-bottom: 1px solid rgba(85,247,165,0.2); padding-bottom: 10px; margin-bottom: 12px;">
            <span style="color: #B8C0BC;">السعرات اليومية المستهدفة</span>
            <span style="font-weight: 900; color: #55F7A5; font-size: 1.1rem;">${targets.targetCalories} سعرة</span>
          </div>

          <div style="display: flex; justify-content: space-between; border-bottom: 1px solid rgba(85,247,165,0.2); padding-bottom: 10px; margin-bottom: 12px;">
            <span style="color: #B8C0BC;">الماكروز المستهدفة</span>
            <span style="font-weight: 700; color: #FFFFFF;">بروتين ${targets.protein}غ | كارب ${targets.carbs}غ | دهون ${targets.fats}غ</span>
          </div>

          <div style="display: flex; justify-content: space-between; border-bottom: 1px solid rgba(85,247,165,0.2); padding-bottom: 10px; margin-bottom: 12px;">
            <span style="color: #B8C0BC;">توزيع وشكل الخطة</span>
            <span style="font-weight: 800; color: #FFFFFF;">${(formData.nutritionPlanPreferences?.mealSlots === 'breakfast_lunch_dinner' ? '3 وجبات' : 'وجبتان')} (${formData.nutritionPlanPreferences?.dietStyle === 'flexible' ? 'مرن' : 'صارم'} - ${formData.nutritionPlanPreferences?.planFormat === 'multiple_options' ? 'بدائل متعددة' : 'خيار ثابت'})</span>
          </div>

          ${formData.nutritionPlanPreferences?.offPlanMealsCount > 0 ? `
            <div style="display: flex; justify-content: space-between; border-bottom: 1px solid rgba(85,247,165,0.2); padding-bottom: 10px; margin-bottom: 12px;">
              <span style="color: #B8C0BC;">الوجبات المفتوحة</span>
              <span style="font-weight: 800; color: #55F7A5;">${formData.nutritionPlanPreferences.offPlanMealsCount} وجبات حرة بالأسبوع</span>
            </div>
          ` : ''}

          ${formData.nutritionPlanPreferences?.sweets?.enabled && formData.nutritionPlanPreferences.sweets.servingsPerWeek > 0 ? `
            <div style="display: flex; justify-content: space-between; border-bottom: 1px solid rgba(85,247,165,0.2); padding-bottom: 10px; margin-bottom: 12px;">
              <span style="color: #B8C0BC;">حصة الحلويات المحسوبة</span>
              <span style="font-weight: 800; color: #FFC83C;">${formData.nutritionPlanPreferences.sweets.item?.nameAr || 'حلويات'} (${formData.nutritionPlanPreferences.sweets.portion || 50}غم) × ${formData.nutritionPlanPreferences.sweets.servingsPerWeek} أسبوعياً</span>
            </div>
          ` : ''}

          <div style="display: flex; justify-content: space-between; border-bottom: 1px solid rgba(85,247,165,0.2); padding-bottom: 10px; margin-bottom: 12px;">
            <span style="color: #B8C0BC;">أيام التدريب</span>
            <span style="font-weight: 800; color: #FFFFFF;">${formData.workoutDaysCount} أيام بالأسبوع (${eqText})</span>
          </div>

          <div style="display: flex; justify-content: space-between;">
            <span style="color: #B8C0BC;">الهدف اليومي للماء</span>
            <span style="font-weight: 800; color: #38BDF8;">${(targets.waterMl / 1000).toFixed(1)} لتر (${targets.waterGlasses} أكواب)</span>
          </div>
        </div>

        <button id="create-my-plan-btn" class="btn btn-primary btn-lg btn-block" style="border-radius: 22px; font-size: 1.15rem; display: flex; align-items: center; justify-content: center; gap: 8px;">
          ${neonIcon('dumbbell', 22)}
          <span>إنشاء خطتي الآن</span>
        </button>

        <!-- تجربة وهندسة توليد الخطة التفاعلية الفورية (Plan Generation Overlay) -->
        <div id="plan-gen-overlay" class="plan-gen-overlay" style="display: none;">
          <div class="plan-gen-panel">
            
            <div class="plan-gen-avatar">
              <div class="plan-gen-ring-pulse"></div>
              <div class="plan-gen-ring-spin"></div>
              <div class="plan-gen-core">
                <span id="plan-gen-core-icon"></span>
              </div>
            </div>

            <div>
              <h3 style="color: #FFFFFF; font-size: 1.3rem; font-weight: 900; margin: 0 0 6px;">
                جاري هندسة خطتك الشخصية
              </h3>
              <p style="color: #8C9992; font-size: 0.82rem; margin: 0; line-height: 1.4;">
                محرك الذكاء الاصطناعي يقوم بحساب السعرات والتمارين المناسبة لجسمك
              </p>
            </div>

            <!-- شريط التقدم والنسبة المئوية -->
            <div style="width: 100%; display: flex; flex-direction: column; gap: 6px;">
              <div style="display: flex; justify-content: space-between; align-items: center; font-size: 0.82rem; font-weight: 800;">
                <span id="plan-gen-action-label" style="color: #55F7A5;">تحليل المقاييس الحيوية...</span>
                <span id="plan-gen-percent-label" style="color: #FFFFFF; font-family: monospace; font-size: 0.95rem;">0%</span>
              </div>
              <div style="width: 100%; height: 8px; background: rgba(255,255,255,0.08); border-radius: 999px; overflow: hidden; border: 1px solid rgba(85,247,165,0.2);">
                <div id="plan-gen-progress-bar" style="width: 0%; height: 100%; background: linear-gradient(90deg, #38BDF8, #55F7A5); border-radius: 999px; transition: width 0.35s ease; box-shadow: 0 0 10px #55F7A5;"></div>
              </div>
            </div>

            <!-- قائمة خطوات هندسة الخطة الحية -->
            <div class="plan-gen-checklist">
              <div class="plan-step-item" id="plan-step-1">
                <span class="step-icon">1</span>
                <span class="step-text">حساب معدل الحرق اليومي (BMR & TDEE) وهندسة ${formData.goal === 'muscle_gain' ? 'الفائض السعري لبناء الكتلة' : 'عجز السعرات'}</span>
              </div>
              <div class="plan-step-item" id="plan-step-2">
                <span class="step-icon">2</span>
                <span class="step-text">توزيع الماكروز والبروتين واستبعاد الحساسيات وتضمين وجباتك المفضلة</span>
              </div>
              <div class="plan-step-item" id="plan-step-3">
                <span class="step-icon">3</span>
                <span class="step-text">تصميم جدول التمارين لـ ${formData.workoutDaysCount || 4} أيام وتفصيل العضلات المستهدفة</span>
              </div>
              <div class="plan-step-item" id="plan-step-4">
                <span class="step-icon">4</span>
                <span class="step-text">تجهيز أهداف الترطيب اليومي ومزامنة الخطة سحابياً</span>
              </div>
            </div>

          </div>
        </div>
      `;

    default:
      return '';
  }
}

export function showTrainingPlanPreview(draft, createPlanBtnOrOptions = {}) {
  document.getElementById('training-plan-preview-modal')?.remove();
  const modal = document.createElement('div');
  modal.id = 'training-plan-preview-modal';
  modal.style.cssText = 'position:fixed;inset:0;z-index:10050;background:rgba(0,8,5,.92);display:flex;align-items:flex-end;justify-content:center;padding:12px;backdrop-filter:blur(10px);';
  const issues = [...(draft.blockers || []), ...(draft.warnings || [])];
  const isElement = typeof HTMLElement !== 'undefined' && createPlanBtnOrOptions instanceof HTMLElement;
  const onApprove = typeof createPlanBtnOrOptions?.onApprove === 'function' ? createPlanBtnOrOptions.onApprove : null;
  const onCancel = typeof createPlanBtnOrOptions?.onCancel === 'function' ? createPlanBtnOrOptions.onCancel : null;
  const createPlanBtn = isElement ? createPlanBtnOrOptions : null;

  modal.innerHTML = `<section role="dialog" aria-modal="true" aria-labelledby="training-preview-title" style="width:min(920px,100%);max-height:92vh;overflow:auto;background:#03120c;border:1px solid rgba(85,247,165,.35);border-radius:24px;padding:20px;box-shadow:0 0 45px rgba(85,247,165,.14);direction:rtl;">
    <div style="display:flex;justify-content:space-between;gap:12px;align-items:flex-start;">
      <div><span style="color:#55F7A5;font-size:.8rem;font-weight:800;">معاينة قبل الاعتماد · ${escapeAttr(draft.splitName)}</span><h2 id="training-preview-title" style="color:#fff;margin:6px 0;">خطتك التدريبية الشخصية</h2><p style="color:#9BA9A2;margin:0;">لن تتغير خطتك الحالية قبل الضغط على «اعتماد الخطة».</p></div>
      <button type="button" data-preview-action="cancel" aria-label="إغلاق" style="background:transparent;border:0;color:#fff;font-size:1.7rem;cursor:pointer;">×</button>
    </div>
    <div style="margin:14px 0;padding:12px;border-radius:14px;background:rgba(85,247,165,.07);border:1px solid rgba(85,247,165,.18);color:#D8E3DE;">
      <strong style="color:#55F7A5;">المستوى المختار محفوظ: ${escapeAttr(draft.selectedLevel)}</strong><div style="margin-top:5px;">${escapeAttr(draft.suggestedStartingPoint)}</div>
    </div>
    ${issues.length ? `<div style="display:grid;gap:7px;margin-bottom:14px;">${issues.map((issue, index) => `<div style="padding:10px 12px;border-radius:12px;background:${index < draft.blockers.length ? 'rgba(248,113,113,.1)' : 'rgba(251,191,36,.09)'};border:1px solid ${index < draft.blockers.length ? 'rgba(248,113,113,.35)' : 'rgba(251,191,36,.28)'};color:#fff;">${escapeAttr(issue)}</div>`).join('')}</div>` : ''}
    ${draft.scheduleConflict ? `<div style="margin-bottom:14px;"><strong style="color:#fff;">اختر عدداً متوافقاً مع نفس النظام:</strong><div style="display:flex;gap:8px;margin-top:8px;">${draft.scheduleConflict.supportedDays.map(days => `<button type="button" data-preview-days="${days}" class="btn btn-secondary">${days} أيام</button>`).join('')}</div></div>` : ''}
    <div style="display:grid;gap:12px;">
      ${draft.days.map(day => `<article style="border:1px solid rgba(85,247,165,.18);border-radius:16px;padding:14px;background:rgba(255,255,255,.02);"><div style="display:flex;justify-content:space-between;gap:8px;"><strong style="color:#55F7A5;">${escapeAttr(day.label)}</strong><span style="color:#9BA9A2;">≈ ${day.estimatedMinutes} دقيقة</span></div><p style="color:#9BA9A2;font-size:.82rem;">${escapeAttr(day.warmup)}</p><div style="display:grid;gap:7px;">${day.exercises.map(exercise => `<div style="display:grid;grid-template-columns:44px 1fr auto;gap:9px;align-items:center;padding:8px;border-radius:10px;background:rgba(0,0,0,.22);"><img src="${escapeAttr(exercise.image)}" alt="" loading="lazy" style="width:44px;height:44px;border-radius:9px;object-fit:cover;"><div><strong style="color:#fff;font-size:.88rem;">${escapeAttr(exercise.title)}</strong><small style="display:block;color:#8C9992;margin-top:3px;">${escapeAttr(exercise.reason)}</small></div><span style="color:#55F7A5;font-weight:800;white-space:nowrap;">${exercise.sets} × ${escapeAttr(exercise.reps)}<small style="display:block;color:#9BA9A2;">راحة ${exercise.restSeconds}ث · RIR ${exercise.rir}</small></span></div>`).join('')}</div></article>`).join('')}
    </div>
    <div style="position:sticky;bottom:-20px;background:linear-gradient(transparent,#03120c 18%);padding:28px 0 2px;display:grid;grid-template-columns:1fr 1fr;gap:10px;">
      <button type="button" data-preview-action="approve" class="btn btn-primary" ${draft.canApprove ? '' : 'disabled'}>اعتماد الخطة</button>
      <button type="button" data-preview-action="cancel" class="btn btn-secondary">إبقاء الخطة الحالية</button>
    </div>
  </section>`;
  document.body.appendChild(modal);
  modal.querySelectorAll('[data-preview-action="cancel"]').forEach(button => button.addEventListener('click', () => {
    fortyDayWorkoutService.discardPendingPlanDraft(draft.id);
    modal.remove();
    if (createPlanBtn) createPlanBtn.disabled = false;
    if (onCancel) onCancel();
  }));
  modal.querySelectorAll('[data-preview-days]').forEach(button => button.addEventListener('click', () => {
    const nextDays = Number(button.dataset.previewDays);
    if (typeof formData !== 'undefined' && formData) formData.workoutDaysCount = nextDays;
    const splitKey = draft.splitKey || fortyDayWorkoutService.getActivePlan();
    const baseInput = (typeof formData !== 'undefined' && formData) ? { ...formData, trainingGoal: formData.goal } : (draft.inputSnapshot || {});
    const nextDraft = generatePersonalizedTrainingDraft({ ...baseInput, workoutDaysCount: nextDays }, { splitKey });
    fortyDayWorkoutService.savePlanDraft(nextDraft);
    showTrainingPlanPreview(nextDraft, createPlanBtnOrOptions);
  }));
  modal.querySelector('[data-preview-action="approve"]')?.addEventListener('click', () => {
    modal.remove();
    if (onApprove) {
      onApprove(draft);
    } else if (createPlanBtn) {
      approvedTrainingDraft = draft;
      createPlanBtn.click();
    }
  });
}

let stopBodyFatPhotoLoading = () => {};
export function bindQuestionnaireEvents() {
  // Rebinding after a step change must not leave image observers alive.
  stopBodyFatPhotoLoading();
  stopBodyFatPhotoLoading = () => {};
  const welcomeStartBtn = document.getElementById('q-welcome-start-btn');
  if (welcomeStartBtn) {
    welcomeStartBtn.onclick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      showWelcomeScreen = false;
      currentStep = 1;
      const container = document.querySelector('.questionnaire-container');
      if (container) {
        const activeSteps = getActiveSteps();
        const totalSteps = activeSteps.length;
        const currentStepKey = activeSteps[0];
        container.innerHTML = renderStepWorkflowHTML(1, totalSteps, currentStepKey);
        bindQuestionnaireEvents();
        const scrollToTop = () => {
          try { window.scrollTo({ top: 0, left: 0, behavior: 'instant' }); } catch (_) { window.scrollTo(0, 0); }
          if (document.documentElement) document.documentElement.scrollTop = 0;
          if (document.body) document.body.scrollTop = 0;
          const cont = document.getElementById('view-container');
          if (cont) cont.scrollTop = 0;
          const root = document.getElementById('app');
          if (root) root.scrollTop = 0;
        };
        scrollToTop();
        requestAnimationFrame(scrollToTop);
      }
    };
    return;
  }

  const activeSteps = getActiveSteps();
  const totalSteps = activeSteps.length;
  const currentStepKey = activeSteps[currentStep - 1] || activeSteps[0];

  if (METABOLIC_STEP_KEYS.includes(currentStepKey)) {
    const root = document.getElementById('metabolic-onboarding');
    const save = () => {
      Object.assign(formData, collectMetabolicAnswers(root, formData, localDate()));
      updateMetabolicVisibility(root, formData);
    };
    root?.addEventListener('change', save);
    root?.addEventListener('input', save);
    if (root) updateMetabolicVisibility(root, formData);
  }
  const nextBtn = document.getElementById('q-next-step-btn');
  const backBtn = document.getElementById('q-back-step-btn');
  const createPlanBtn = document.getElementById('create-my-plan-btn');

  // تهيئة الأحداث المناسبة بحسب مفتاح الخطوة النشطة
  if (currentStepKey === STEP_KEYS.MEASUREMENTS) {
    // Resolve the R2 origin while users enter their measurements, so the
    // first image does not pay DNS/TLS setup time after they tap Next.
    if (!document.querySelector('link[data-neon-body-fat-preconnect]')) {
      const hint = document.createElement('link');
      hint.rel = 'preconnect';
      hint.crossOrigin = 'anonymous';
      hint.href = new URL(getBodyFatRanges(formData.gender)[0].image).origin;
      hint.dataset.neonBodyFatPreconnect = '';
      document.head.appendChild(hint);
    }
    initStep1HorizontalPickers();
  } else if (currentStepKey === STEP_KEYS.BODY_FAT) {
    initBodyFatStepEvents();
  } else if (currentStepKey === STEP_KEYS.GOAL) {
    initGoalStepEvents();
  } else if (currentStepKey === STEP_KEYS.WEEKLY_LOSS_RATE) {
    initWeeklyLossRateEvents();
  } else if (currentStepKey === STEP_KEYS.WEEKLY_GAIN_RATE) {
    initWeeklyGainRateEvents();
  } else if (currentStepKey === STEP_KEYS.NUTRITION) {
    initNutritionStepEvents();
  } else if (
    currentStepKey === STEP_KEYS.PLAN_PREFERENCES ||
    currentStepKey === STEP_KEYS.PLAN_PREFERENCES_2
  ) {
    initPlanPreferencesStepEvents();
  } else if (currentStepKey === STEP_KEYS.HEALTH) {
    initHealthStepEvents();
  } else if (currentStepKey === STEP_KEYS.SUPPLEMENTS) {
    initSupplementsStepEvents();
  }

  // التقدم للخطوة التالية
  if (nextBtn) {
    nextBtn.onclick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      const stepsNow = getActiveSteps();
      const totalNow = stepsNow.length;
      const stepKeyNow = stepsNow[currentStep - 1] || stepsNow[0];

      if (stepKeyNow === STEP_KEYS.BODY_FAT && !getBodyFatRange(formData.bodyFatRange, formData.gender)) {
        notificationService.showToast('اختَر نسبة الدهون التقريبية من الصور قبل المتابعة', 'warning');
        return;
      }

      if (METABOLIC_STEP_KEYS.includes(stepKeyNow)) {
        saveCurrentStepInputs();
        const error = validateMetabolicAnswers(stepKeyNow, formData, localDate());
        if (error) { notificationService.showToast(error, 'warning'); return; }
      }

      // التحقق عند الخطوة 2 لهدف خسارة الدهون: الوزن المستهدف يجب أن يكون أقل
      if (stepKeyNow === STEP_KEYS.GOAL && formData.goal === 'fat_loss') {
        const targetWeight = Number(document.getElementById('q-target-weight')?.value) || formData.targetWeight;
        const weight = Number(formData.weight) || 70;
        if (targetWeight >= weight) {
          notificationService.showToast(`لهدف خسارة الدهون، يجب أن يكون الوزن المستهدف أقل من وزنك الحالي (${weight} كغ)`, 'warning');
          return;
        }
      }

      // التحقق عند الخطوة 2 لهدف زيادة الكتلة: الوزن المستهدف يجب أن يكون أكبر
      if (stepKeyNow === STEP_KEYS.GOAL && formData.goal === 'muscle_gain') {
        const targetWeight = Number(document.getElementById('q-target-weight')?.value) || formData.targetWeight;
        const weight = Number(formData.weight) || 70;
        if (targetWeight <= weight) {
          notificationService.showToast(`لهدف زيادة الكتلة، يجب أن يكون الوزن المستهدف أكبر من وزنك الحالي (${weight} كغ)`, 'warning');
          return;
        }
      }

      // التحقق عند شاشة معدل النزول: التأكيد لمعدل 2% EXTREME
      if (stepKeyNow === STEP_KEYS.WEEKLY_LOSS_RATE) {
        if (formData.weeklyLossPercent >= 0.02 && !extremeConfirmed) {
          const modal = document.getElementById('extreme-loss-modal');
          if (modal) {
            modal.style.display = 'flex';
            return;
          }
        }
      }

      // التحقق عند شاشة معدل زيادة الوزن: التأكيد لمعدل 2% EXTREME BULK
      if (stepKeyNow === STEP_KEYS.WEEKLY_GAIN_RATE) {
        if ((formData.weeklyGainPercent || 0.0050) >= 0.02 && !extremeGainConfirmed) {
          const modal = document.getElementById('extreme-gain-modal');
          if (modal) {
            modal.style.display = 'flex';
            return;
          }
        }
      }

      // التحقق عند شاشة الصحة: استكمال بيانات الإصابات إن وُجدت قبل المتابعة
      if (stepKeyNow === STEP_KEYS.HEALTH) {
        saveCurrentStepInputs();
        const incomplete = (formData.injuries || []).filter(region => {
          const detail = formData.injuryDetails?.[region];
          return !detail?.status && !detail?.triggerMovements && (!detail?.painSeverity || detail.painSeverity === 0) && detail?.medicalBan === 'none';
        });
        if (incomplete.length > 0) {
          const names = incomplete.map(r => INJURY_REGION_LABELS[r] || r).join('، ');
          notificationService.showToast(`يرجى استكمال تفاصيل (${names}) قبل المتابعة لتخصيص خطتك بأمان ودقة`, 'warning');
          return;
        }
      }

      saveCurrentStepInputs();
      if (currentStep < totalNow) {
        currentStep++;
        render();
      }
    };
  }

  // الرجوع للخطوة السابقة (خطوة واحدة للخلف بدقة، والرجوع من الخطوة 1 يعود لشاشة الترحيب)
  if (backBtn) {
    backBtn.onclick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (currentStep > 1) {
        saveCurrentStepInputs();
        currentStep--;
        render();
      } else if (currentStep === 1) {
        saveCurrentStepInputs();
        showWelcomeScreen = true;
        const container = document.querySelector('.questionnaire-container');
        if (container) {
          container.innerHTML = renderWelcomeScreenHTML();
          bindQuestionnaireEvents();
          const scrollToTop = () => {
            try { window.scrollTo({ top: 0, left: 0, behavior: 'instant' }); } catch (_) { window.scrollTo(0, 0); }
            if (document.documentElement) document.documentElement.scrollTop = 0;
            if (document.body) document.body.scrollTop = 0;
            const cont = document.getElementById('view-container');
            if (cont) cont.scrollTop = 0;
            const root = document.getElementById('app');
            if (root) root.scrollTop = 0;
          };
          scrollToTop();
          requestAnimationFrame(scrollToTop);
        }
      }
    };
  }

  // عند التسجيل: إنشاء الخطة مباشرة دون نافذة "معاينة قبل الاعتماد".
  // تبقى نافذة المعاينة متاحة عند تعديل خطة موجودة داخل تبويب التدريب.
  createPlanBtn?.addEventListener('click', async () => {
    if (createPlanBtn.disabled) return;
    let activeSplit = fortyDayWorkoutService.getActivePlan();
    const currentSchedule = SPLIT_SCHEDULES[activeSplit];
    if (currentSchedule && !currentSchedule.supportedDays.includes(formData.workoutDaysCount)) {
      if (SPLIT_SCHEDULES.hasm.supportedDays.includes(formData.workoutDaysCount)) {
        activeSplit = 'hasm';
      } else if (SPLIT_SCHEDULES.ppl.supportedDays.includes(formData.workoutDaysCount)) {
        activeSplit = 'ppl';
      }
    }
    const trainingDraftToActivate = generatePersonalizedTrainingDraft(
      { ...formData, trainingGoal: formData.goal },
      { splitKey: activeSplit }
    );
    // Never silently activate an incomplete or medically blocked plan.
    if (!trainingDraftToActivate.canApprove) {
      notificationService.showToast(
        (trainingDraftToActivate.blockers || []).join(' ') || 'تعذّر إنشاء الخطة. راجع بيانات التدريب والإصابات.',
        'warning'
      );
      return;
    }
    // A fresh account may currently have an old/default split selected.
    // Align the active split only after validating the generated draft, since
    // activation requires draft.splitKey === getActivePlan().
    if (trainingDraftToActivate.splitKey !== fortyDayWorkoutService.getActivePlan()) {
      fortyDayWorkoutService.setActivePlan(trainingDraftToActivate.splitKey);
    }
    fortyDayWorkoutService.savePlanDraft(trainingDraftToActivate);
    const overlay = document.getElementById('plan-gen-overlay');
    const coreIcon = document.getElementById('plan-gen-core-icon');
    const actionLabel = document.getElementById('plan-gen-action-label');
    const percentLabel = document.getElementById('plan-gen-percent-label');
    const progressBar = document.getElementById('plan-gen-progress-bar');
    const step1 = document.getElementById('plan-step-1');
    const step2 = document.getElementById('plan-step-2');
    const step3 = document.getElementById('plan-step-3');
    const step4 = document.getElementById('plan-step-4');

    if (overlay) overlay.style.display = 'flex';
    createPlanBtn.disabled = true;

    const setStepState = (stepEl, state) => {
      if (!stepEl) return;
      stepEl.classList.remove('active', 'completed');
      if (state === 'active') {
        stepEl.classList.add('active');
        const icon = stepEl.querySelector('.step-icon');
        if (icon) icon.innerHTML = `<span style="animation: spin 1.2s infinite linear; display: inline-block;"></span>`;
      } else if (state === 'completed') {
        stepEl.classList.add('completed');
        const icon = stepEl.querySelector('.step-icon');
        if (icon) icon.textContent = '✓';
      }
    };

    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
    const finishAfterMinimum = async (startedAt, minimumMs = 320) => {
      await sleep(Math.max(0, minimumMs - (Date.now() - startedAt)));
    };
    const showStage = (step, label, percent) => {
      if (coreIcon) coreIcon.textContent = '';
      if (actionLabel) actionLabel.textContent = label;
      if (percentLabel) percentLabel.textContent = `${percent}%`;
      if (progressBar) progressBar.style.width = `${percent}%`;
      setStepState(step, 'active');
      try { navigator.vibrate?.(30); } catch (_) {}
    };

    try {
      // كل مرحلة تنتهي فقط بعد اكتمال العمل الحقيقي الخاص بها.
      let startedAt = Date.now();
      showStage(step1, 'حساب معدل الحرق اليومي (BMR) وضبط العجز...', 25);
      const targets = calculateNutritionTargets(formData);
      await finishAfterMinimum(startedAt);
      setStepState(step1, 'completed');

      startedAt = Date.now();
      showStage(step2, 'توزيع الماكروز والبروتين وتجهيز المكملات المختارة...', 55);
      const selectedStackItems = (formData.supplements || [])
        .map(name => SUPPLEMENT_DB.find(item => item.name === name))
        .filter(Boolean)
        .map(item => ({
          id: `item_${item.name.toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '')}`,
          name: item.displayName,
          dose: item.dose,
          window: item.window,
          note: item.note
        }));
      const fullProfile = {
      ...formData,
      currentWeight: formData.weight,
      startWeight: formData.weight,
      bmr: targets.bmr,
      maintenanceCalories: targets.tdee,
      selectedWeeklyLossRate: formData.selectedWeeklyLossRate || formData.weeklyLossPercent,
      selectedWeeklyLossPercent: formData.selectedWeeklyLossPercent || formData.weeklyLossPercent,
      selectedWeeklyLossKg: formData.selectedWeeklyLossKg || formData.weeklyLossKg,
      weeklyLossPercent: formData.weeklyLossPercent,
      weeklyLossKg: formData.weeklyLossKg,
      weeklyCalorieDeficit: formData.weeklyCalorieDeficit,
      dailyCalorieDeficit: formData.dailyCalorieDeficit,
      requestedTargetCalories: targets.targetCalories,
      requestedCalories: targets.targetCalories,
      estimatedGoalWeeks: formData.estimatedGoalWeeks,
      weightLossRiskLevel: formData.weightLossRiskLevel,
      calorieSafetyLevel: formData.calorieSafetyLevel,
      calorieWarningCodes: formData.calorieWarningCodes || [],
      calculationFormula: targets.rmrMethod,
      rmrMethodUsed: targets.rmrMethod,
      rmr: targets.rmr,
      targetMode: formData.targetMode || 'coached',
      floorApplied: targets.floorApplied,
      macroWarnings: targets.macroWarnings,
      targetCalories: targets.targetCalories,
      targetProtein: targets.protein,
      targetCarbs: targets.carbs,
      targetFats: targets.fats,
      targetWaterLiters: Number((targets.waterMl / 1000).toFixed(1)),
      targetGlasses: targets.waterGlasses,
      nutritionPlanPreferences: formData.nutritionPlanPreferences,
      onboardingCompleted: true,
      onboarding_completed: true
      };
      await finishAfterMinimum(startedAt);
      setStepState(step2, 'completed');

      startedAt = Date.now();
      showStage(step3, `هندسة جدول التمارين لـ ${formData.workoutDaysCount || 4} أيام وتفصيل العضلات...`, 80);
      const trainingPlan = trainingDraftToActivate;
      await finishAfterMinimum(startedAt);
      setStepState(step3, 'completed');

      startedAt = Date.now();
      const hasAuthenticatedAccount = authService.isAuthenticated();
      showStage(step4, 'حفظ الخطة وتجهيز صفحة اليوم...', 95);
      const activation = await fortyDayWorkoutService.activatePersonalizedPlan(trainingPlan, { requestId: trainingPlan.requestId });
      if (!activation.ok) throw new Error((activation.errors || ['تعذر اعتماد الخطة التدريبية.']).join(' '));
      fullProfile.workoutPlan = trainingPlan.splitKey;
      fullProfile.activeTrainingPlanVersionId = activation.versionId;
      store.setUserProfile(fullProfile);
      store.setDailyStackItems(selectedStackItems);


      const state = store.getState();
      state.onboardingAuthPending = !hasAuthenticatedAccount;
      Object.assign(state.today, {
        targetCalories: targets.targetCalories,
        targetProtein: targets.protein,
        targetCarbs: targets.carbs,
        targetFats: targets.fats,
        targetWaterLiters: Number((targets.waterMl / 1000).toFixed(1)),
        targetGlasses: targets.waterGlasses,
        consumedCalories: 0,
        consumedProtein: 0,
        consumedCarbs: 0,
        consumedFats: 0,
        meals: [],
        waterGlasses: 0,
        waterMl: 0
      });
      store.recalculateTargetsFromProfile();
      nutritionPlanService.generateAndSavePlan(store.getState().userProfile, formData.nutritionPlanPreferences);
      store.saveState();

      const userId = authService.getEffectiveUserId();
      if (userId) {
        try {
          await syncService.syncProfile(userId, fullProfile);
          await syncService.syncWaterLog(userId, 0, 0, targets.waterGlasses);
        } catch (syncErr) {
          console.warn('Sync warning upon plan creation:', syncErr);
        }
      }
      await finishAfterMinimum(startedAt, 400);
      setStepState(step4, 'completed');
      if (percentLabel) percentLabel.textContent = '100%';
      if (progressBar) progressBar.style.width = '100%';
      if (coreIcon) coreIcon.textContent = '';
      if (actionLabel) actionLabel.textContent = 'اكتملت خطتك بنجاح! جاري فتح صفحة اليوم...';
      notificationService.showToast(`تم إنشاء وتفعيل خطتك الشخصية بنجاح يا ${formData.name || 'بطل'}!`, 'success');
      await sleep(450);
      currentStep = 1;
      showWelcomeScreen = true;
      approvedTrainingDraft = null;
      window.location.hash = '#today'; // [مؤقت] لا يُطلب تسجيل الدخول
    } catch (error) {
      console.error('Plan generation failed:', error);
      if (actionLabel) actionLabel.textContent = 'تعذر إكمال إنشاء الحساب. أعد المحاولة.';
      if (percentLabel) percentLabel.textContent = 'خطأ';
      createPlanBtn.disabled = false;
      approvedTrainingDraft = null;
      notificationService.showToast('تعذر إنشاء الخطة. لم يتم نقلك قبل اكتمال الحفظ.', 'error');
    }
  });

  function initStep1HorizontalPickers() {
    const setupTrack = (id, initialVal, unitStr, onChange) => {
      const track = document.getElementById(`track-${id}`);
      const capsuleVal = document.getElementById(`capsule-val-${id}`);
      const rowVal = document.getElementById(`row-val-${id}`);
      const hiddenInput = document.getElementById(`q-${id}`);
      if (!track) return null;

      let isReady = false;

      const scrollToVal = (val, smooth = true) => {
        if (!track || track.clientWidth === 0) return;
        const item = track.querySelector(`.picker-tick-item[data-val="${val}"]`);
        if (item) {
          const targetScroll = item.offsetLeft - (track.clientWidth / 2) + (item.clientWidth / 2);
          track.scrollTo({ left: targetScroll, behavior: smooth ? 'smooth' : 'instant' });
        }
      };

      const updateActiveItem = () => {
        if (!track || track.clientWidth === 0) return;
        const center = track.scrollLeft + (track.clientWidth / 2);
        const items = track.querySelectorAll('.picker-tick-item');
        let closestItem = null;
        let minDistance = Infinity;

        for (const it of items) {
          const itemCenter = it.offsetLeft + (it.clientWidth / 2);
          const dist = Math.abs(center - itemCenter);
          if (dist < minDistance) {
            minDistance = dist;
            closestItem = it;
          }
        }

        if (closestItem) {
          const val = Number(closestItem.dataset.val);
          items.forEach(it => it.classList.remove('active'));
          closestItem.classList.add('active');

          if (rowVal) rowVal.textContent = `${val} ${unitStr}`;
          if (hiddenInput) hiddenInput.value = val;
          if (typeof onChange === 'function') onChange(val);
        }
      };

      // رصد التمرير لتحديث الرقم النشط فورياً فقط بعد اكتمال التموضع
      track.addEventListener('scroll', () => {
        if (!isReady) return;
        updateActiveItem();
      }, { passive: true });

      // النقر المباشر على أي رقم يجعله في المركز
      track.querySelectorAll('.picker-tick-item').forEach(item => {
        item.addEventListener('click', (e) => {
          e.stopPropagation();
          const val = Number(item.dataset.val);
          scrollToVal(val, true);
        });
      });

      // دعم السحب بالفأرة على أجهزة الكمبيوتر
      let isDown = false;
      let startX = 0;
      let scrollLeft = 0;

      track.addEventListener('mousedown', (e) => {
        isDown = true;
        startX = e.pageX - track.offsetLeft;
        scrollLeft = track.scrollLeft;
      });

      const onMouseUp = () => {
        if (isDown) {
          isDown = false;
          const center = track.scrollLeft + (track.clientWidth / 2);
          const items = track.querySelectorAll('.picker-tick-item');
          let closestItem = null;
          let minDistance = Infinity;
          for (const it of items) {
            const itemCenter = it.offsetLeft + (it.clientWidth / 2);
            const dist = Math.abs(center - itemCenter);
            if (dist < minDistance) { minDistance = dist; closestItem = it; }
          }
          if (closestItem) {
            scrollToVal(Number(closestItem.dataset.val), true);
          }
        }
      };

      window.addEventListener('mouseup', onMouseUp);

      track.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - track.offsetLeft;
        const walk = (x - startX) * 1.5;
        track.scrollLeft = scrollLeft - walk;
      });

      // دعم عجلة الفأرة (Mouse Wheel) للتمرير الأفقي
      track.addEventListener('wheel', (e) => {
        if (e.deltaY) {
          e.preventDefault();
          track.scrollLeft += (e.deltaY * 0.7);
        }
      }, { passive: false });

      // محاذاة القيمة الافتراضية في المركز فور التحميل بدقة وتفعيل الرصد
      scrollToVal(initialVal, false);
      updateActiveItem();
      setTimeout(() => {
        scrollToVal(initialVal, false);
        updateActiveItem();
        isReady = true;
      }, 100);

      return { scrollToVal, updateActiveItem, setReady: (val) => { isReady = val; } };
    };

    // مراقبة إدخال الاسم الأول
    document.getElementById('q-name')?.addEventListener('input', (e) => {
      formData.name = e.target.value.trim();
    });

    // 1. تهيئة مسار العمر (افتراضي 18 سنة)
    const ageCtrl = setupTrack('age', formData.age, 'سنة', (val) => {
      formData.age = val;
    });

    // 2. تهيئة مسار الوزن (افتراضي 70 كغ)
    const currentWeightDisp = weightUnit === 'kg' ? formData.weight : Math.round(kgToLbs(formData.weight));
    const currentWeightUnitStr = weightUnit === 'kg' ? 'كغ' : 'lb';
    let weightCtrl = setupTrack('weight', currentWeightDisp, currentWeightUnitStr, (val) => {
      if (weightUnit === 'kg') {
        formData.weight = val;
      } else {
        formData.weight = Math.round(lbsToKg(val));
      }
    });

    // 3. تهيئة مسار الطول (افتراضي 175 سم)
    const heightCtrl = setupTrack('height', formData.height, 'سم', (val) => {
      formData.height = val;
    });

    // ربط الأكورديون للنقر على الصفوف
    const rowConfigs = [
      { id: 'age', getCtrl: () => ageCtrl, getVal: () => formData.age },
      { id: 'weight', getCtrl: () => weightCtrl, getVal: () => (weightUnit === 'kg' ? formData.weight : Math.round(kgToLbs(formData.weight))) },
      { id: 'height', getCtrl: () => heightCtrl, getVal: () => formData.height }
    ];

    rowConfigs.forEach(r => {
      const rowEl = document.getElementById(`row-${r.id}`);
      const drawerEl = document.getElementById(`drawer-${r.id}`);
      if (rowEl && drawerEl) {
        rowEl.addEventListener('click', (e) => {
          if (e.target.closest('.unit-toggle-pills')) return;
          const isOpen = drawerEl.classList.contains('open');
          // إغلاق كل الأدراج أولاً
          rowConfigs.forEach(other => {
            document.getElementById(`drawer-${other.id}`)?.classList.remove('open');
            document.getElementById(`row-${other.id}`)?.classList.remove('active');
          });
          if (!isOpen) {
            drawerEl.classList.add('open');
            rowEl.classList.add('active');
            activeMeasurementDrawer = r.id;
            setTimeout(() => {
              const ctrl = r.getCtrl();
              if (ctrl) {
                ctrl.scrollToVal(r.getVal(), false);
                ctrl.updateActiveItem();
                ctrl.setReady(true);
              }
            }, 60);
          } else {
            activeMeasurementDrawer = null;
          }
        });
      }
    });

    // أزرار التقديم والتأخير (❮ و ❯)
    document.querySelectorAll('.picker-nudge-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const target = btn.dataset.target;
        const track = document.getElementById(`track-${target}`);
        if (!track) return;
        const isNext = btn.classList.contains('picker-nudge-next');
        const itemWidth = 70;
        track.scrollBy({ left: isNext ? itemWidth : -itemWidth, behavior: 'smooth' });
      });
    });

    // تبديل أزرار الجنس (ذكر / أنثى)
    document.querySelectorAll('.gender-pill-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const g = btn.dataset.gender;
        formData.gender = g;
        // If the user changes sex after returning from body-fat selection,
        // clear a range that does not exist in the new set of nine images.
        const retained = getBodyFatRange(formData.bodyFatRange, g);
        formData.bodyFatRange = retained?.label || '';
        formData.bodyFatPercent = retained?.estimate ?? null;
        document.querySelectorAll('.gender-pill-btn').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        const gInput = document.getElementById('q-gender');
        if (gInput) gInput.value = g;
      });
    });

    // تبديل وحدات الوزن (kg / lb)
    document.querySelectorAll('.unit-pill').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const u = btn.dataset.unit;
        if (u === weightUnit) return;
        weightUnit = u;
        document.querySelectorAll('.unit-pill').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');

        const drawer = document.getElementById('drawer-weight');
        const rowValWeight = document.getElementById('row-val-weight');
        if (drawer) {
          const targetVal = u === 'kg' ? formData.weight : Math.round(kgToLbs(formData.weight));
          if (rowValWeight) rowValWeight.textContent = `${targetVal} ${u === 'kg' ? 'كغ' : 'lb'}`;
          drawer.innerHTML = renderHorizontalPickerHTML('weight', u === 'kg' ? 35 : 77, u === 'kg' ? 220 : 485, 1, targetVal, u === 'kg' ? 'كغ' : 'lb');
          weightCtrl = setupTrack('weight', targetVal, u === 'kg' ? 'كغ' : 'lb', (val) => {
            if (weightUnit === 'kg') formData.weight = val;
            else formData.weight = Math.round(lbsToKg(val));
          });
          drawer.querySelectorAll('.picker-nudge-btn').forEach(nb => {
            nb.addEventListener('click', (ev) => {
              ev.stopPropagation();
              const tr = document.getElementById('track-weight');
              const isN = nb.classList.contains('picker-nudge-next');
              tr?.scrollBy({ left: isN ? 70 : -70, behavior: 'smooth' });
            });
          });
        }
      });
    });
  }

  function initGoalStepEvents() {
    const targetWeightInput = document.getElementById('q-target-weight');

    targetWeightInput?.addEventListener('input', (e) => {
      const val = Number(e.target.value);
      if (val > 0) {
        formData.targetWeight = val;
      }
    });


    document.querySelectorAll('.goal-card').forEach(card => {
      card.addEventListener('click', () => {
        document.querySelectorAll('.goal-card').forEach(c => {
          c.classList.remove('glow');
          c.style.borderColor = 'rgba(85,247,165,0.2)';
        });
        card.classList.add('glow');
        card.style.borderColor = '#55F7A5';
        formData.goal = card.getAttribute('data-goal');

        // تعديل افتراضي ذكي للوزن المستهدف حسب الهدف
        const currentW = Number(formData.weight) || 70;
        if (formData.goal === 'muscle_gain' && formData.targetWeight <= currentW) {
          formData.targetWeight = Math.round(currentW + 5);
          if (targetWeightInput) targetWeightInput.value = formData.targetWeight;
        } else if (formData.goal === 'fat_loss' && formData.targetWeight >= currentW) {
          formData.targetWeight = Math.round(currentW - 5);
          if (targetWeightInput) targetWeightInput.value = formData.targetWeight;
        }

        // تحديث شريط الخطوات والمؤشر ديناميكياً فور تغيير الهدف
        const activeSteps = getActiveSteps();
        const totalSteps = activeSteps.length;
        const headerStep = document.getElementById('q-step-indicator-text');
        if (headerStep) {
          headerStep.textContent = `الخطوة ${currentStep} من ${totalSteps}`;
        }
        const stepsBar = document.getElementById('q-steps-bar');
        if (stepsBar) {
          stepsBar.innerHTML = Array.from({ length: totalSteps }, (_, i) => `
            <div style="flex: 1; height: 4px; border-radius: 999px; background: ${i + 1 <= currentStep ? '#55F7A5' : 'rgba(85, 247, 165, 0.15)'}; box-shadow: ${i + 1 === currentStep ? '0 0 8px #55F7A5' : 'none'}; transition: all 0.3s ease;"></div>
          `).join('');
        }
      });
    });
  }

  function initWeeklyLossRateEvents() {
    const extremeModal = document.getElementById('extreme-loss-modal');
    const extremeCheckbox = document.getElementById('extreme-confirm-checkbox');
    const extremeAcceptBtn = document.getElementById('extreme-accept-btn');
    const extremeCancelBtn = document.getElementById('extreme-cancel-btn');

    const updateFatLossSummary = () => {
      const w = Number(formData.weight) || 70;
      const h = Number(formData.height) || 175;
      const age = Number(formData.age) || 18;
      const g = formData.gender || 'male';
      const act = formData.activityLevel || 'moderate';

      const { rawBmr, rawTdee } = metabolismForForm({ gender: g, age, weight: w, height: h, activityLevel: act });

      document.querySelectorAll('.rate-card').forEach(rc => {
        const rateVal = parseFloat(rc.dataset.rate);
        if (!isNaN(rateVal)) {
          const opt = calculateWeightLossOption({
            currentWeightKg: w,
            maintenanceCalories: rawTdee,
            weeklyRate: rateVal,
            sex: g,
            age,
            targetWeightKg: formData.targetWeight
          });
          const kgEl = rc.querySelector('.rate-card-kg');
          if (kgEl) kgEl.textContent = opt.weeklyLossKgRounded.toFixed(2);
          const calEl = rc.querySelector('.rate-card-calories');
          if (calEl) calEl.innerHTML = `${opt.targetCaloriesRounded.toLocaleString('en-US')} <span style="font-size: 0.72rem; font-weight: 600; color: #B8C0BC;">سعرة / يوم</span>`;
          const defEl = rc.querySelector('.rate-card-deficit');
          if (defEl) defEl.textContent = `عجز يومي: ≈ ${opt.dailyDeficitRounded} سعرة`;
        }
      });
    };

    const showExtremeModal = () => {
      if (!extremeModal) return;
      const w = Number(formData.weight) || 70;
      const h = Number(formData.height) || 175;
      const age = Number(formData.age) || 18;
      const g = formData.gender || 'male';
      const act = formData.activityLevel || 'moderate';

      const { rawBmr, rawTdee } = metabolismForForm({ gender: g, age, weight: w, height: h, activityLevel: act });
      const plan = calculateWeightLossOption({
        currentWeightKg: w,
        maintenanceCalories: rawTdee,
        weeklyRate: 0.02,
        sex: g,
        age,
        targetWeightKg: formData.targetWeight || (w - 5)
      });

      const statsDiv = document.getElementById('extreme-modal-stats');
      if (statsDiv) {
        statsDiv.innerHTML = `
          <div style="display: flex; justify-content: space-between; margin-bottom: 6px; color: #E5E7EB;">
            <span>النزول الأسبوعي المقدر:</span>
            <strong style="color: #FBBF24;">${plan.weeklyLossKgRounded.toFixed(2)} كغ / أسبوع</strong>
          </div>
          <div style="display: flex; justify-content: space-between; margin-bottom: 6px; color: #E5E7EB;">
            <span>العجز اليومي المطلوب:</span>
            <strong style="color: #FBBF24;">-${plan.dailyDeficitRounded} سعرة</strong>
          </div>
          <div style="display: flex; justify-content: space-between; color: #E5E7EB;">
            <span>سعراتك اليومية الناتجة:</span>
            <strong style="color: #FBBF24;">${plan.targetCaloriesRounded.toLocaleString('en-US')} سعرة / يوم</strong>
          </div>
        `;
      }

      if (extremeCheckbox) {
        extremeCheckbox.checked = extremeConfirmed;
      }
      if (extremeAcceptBtn) {
        extremeAcceptBtn.disabled = !extremeConfirmed;
        extremeAcceptBtn.style.opacity = extremeConfirmed ? '1' : '0.5';
        extremeAcceptBtn.style.cursor = extremeConfirmed ? 'pointer' : 'not-allowed';
      }

      extremeModal.style.display = 'flex';
    };

    const hideExtremeModal = () => {
      if (extremeModal) extremeModal.style.display = 'none';
    };

    // تفاعل بطاقات المعدلات الستة
    document.querySelectorAll('.rate-card').forEach(rc => {
      const handleSelect = () => {
        if (rc.classList.contains('disabled') || rc.dataset.disabled === 'true') {
          notificationService.showToast('هذا الخيار غير متاح لمن هم دون 18 عاماً للحفاظ على النمو الصحي ', 'warning');
          return;
        }

        const rateVal = parseFloat(rc.dataset.rate);
        if (isNaN(rateVal)) return;

        formData.weeklyLossPercent = rateVal;
        formData.selectedWeeklyLossRate = rateVal;

        const w = Number(formData.weight) || 70;
        const h = Number(formData.height) || 175;
        const age = Number(formData.age) || 18;
        const g = formData.gender || 'male';
        const act = formData.activityLevel || 'moderate';
        const { rawBmr, rawTdee } = metabolismForForm({ gender: g, age, weight: w, height: h, activityLevel: act });
        const opt = calculateWeightLossOption({
          currentWeightKg: w,
          maintenanceCalories: rawTdee,
          weeklyRate: rateVal,
          sex: g,
          age,
          targetWeightKg: formData.targetWeight || (w - 5)
        });
        formData.bmr = Math.round(rawBmr);
        formData.rawBmr = rawBmr;
        formData.maintenanceCalories = Math.round(rawTdee);
        formData.rawMaintenanceCalories = rawTdee;
        formData.selectedWeeklyLossKg = opt.weeklyLossKgRounded;
        formData.weeklyLossKg = opt.weeklyLossKgRounded;
        formData.weeklyCalorieDeficit = opt.weeklyDeficitRounded;
        formData.dailyCalorieDeficit = opt.dailyDeficitRounded;
        formData.requestedTargetCalories = opt.targetCaloriesRounded;
        formData.requestedCalories = opt.targetCaloriesRounded;
        formData.targetCalories = opt.targetCaloriesRounded;
        formData.estimatedGoalWeeks = opt.estimatedWeeks;
        formData.weightLossRiskLevel = opt.safety.safetyLevel;
        formData.calorieSafetyLevel = opt.safety.safetyLevel;
        formData.calorieWarningCodes = opt.safety.warningCodes;

        document.querySelectorAll('.rate-card').forEach(c => {
          c.classList.remove('active-rate');
          c.setAttribute('aria-checked', 'false');
          c.querySelector('.rate-card-check')?.remove();
        });
        rc.classList.add('active-rate');
        rc.setAttribute('aria-checked', 'true');
        const check = document.createElement('div');
        check.className = 'rate-card-check';
        check.textContent = '✓';
        rc.appendChild(check);

        if (rateVal >= 0.02) {
          showExtremeModal();
        } else {
          extremeConfirmed = false;
        }

        updateFatLossSummary();
      };

      rc.addEventListener('click', handleSelect);
      rc.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleSelect();
        }
      });
    });

    // أحداث المودال
    extremeCheckbox?.addEventListener('change', (e) => {
      if (extremeAcceptBtn) {
        extremeAcceptBtn.disabled = !e.target.checked;
        extremeAcceptBtn.style.opacity = e.target.checked ? '1' : '0.5';
        extremeAcceptBtn.style.cursor = e.target.checked ? 'pointer' : 'not-allowed';
      }
    });

    extremeAcceptBtn?.addEventListener('click', () => {
      extremeConfirmed = true;
      hideExtremeModal();
      notificationService.showToast('تم تأكيد اختيار معدل النزول الشديد ', 'info');
    });

    extremeCancelBtn?.addEventListener('click', () => {
      hideExtremeModal();
      formData.weeklyLossPercent = 0.0075;
      formData.selectedWeeklyLossRate = 0.0075;
      extremeConfirmed = false;

      const w = Number(formData.weight) || 70;
      const h = Number(formData.height) || 175;
      const age = Number(formData.age) || 18;
      const g = formData.gender || 'male';
      const act = formData.activityLevel || 'moderate';
      const { rawBmr, rawTdee } = metabolismForForm({ gender: g, age, weight: w, height: h, activityLevel: act });
      const opt = calculateWeightLossOption({
        currentWeightKg: w,
        maintenanceCalories: rawTdee,
        weeklyRate: 0.0075,
        sex: g,
        age,
        targetWeightKg: formData.targetWeight || (w - 5)
      });
      formData.bmr = Math.round(rawBmr);
      formData.rawBmr = rawBmr;
      formData.maintenanceCalories = Math.round(rawTdee);
      formData.rawMaintenanceCalories = rawTdee;
      formData.selectedWeeklyLossKg = opt.weeklyLossKgRounded;
      formData.weeklyLossKg = opt.weeklyLossKgRounded;
      formData.weeklyCalorieDeficit = opt.weeklyDeficitRounded;
      formData.dailyCalorieDeficit = opt.dailyDeficitRounded;
      formData.requestedTargetCalories = opt.targetCaloriesRounded;
      formData.requestedCalories = opt.targetCaloriesRounded;
      formData.targetCalories = opt.targetCaloriesRounded;
      formData.estimatedGoalWeeks = opt.estimatedWeeks;
      formData.weightLossRiskLevel = opt.safety.safetyLevel;
      formData.calorieSafetyLevel = opt.safety.safetyLevel;
      formData.calorieWarningCodes = opt.safety.warningCodes;

      document.querySelectorAll('.rate-card').forEach(c => {
        const isRec = Math.abs(parseFloat(c.dataset.rate) - 0.0075) < 0.0001;
        c.classList.toggle('active-rate', isRec);
        c.setAttribute('aria-checked', String(isRec));
        c.querySelector('.rate-card-check')?.remove();
        if (isRec) {
          const check = document.createElement('div');
          check.className = 'rate-card-check';
          check.textContent = '✓';
          c.appendChild(check);
        }
      });
      updateFatLossSummary();
    });
  }

  function initWeeklyGainRateEvents() {
    const extremeModal = document.getElementById('extreme-gain-modal');
    const extremeCheckbox = document.getElementById('extreme-gain-confirm-checkbox');
    const extremeAcceptBtn = document.getElementById('extreme-gain-accept-btn');
    const extremeCancelBtn = document.getElementById('extreme-gain-cancel-btn');

    const updateWeightGainSummary = () => {
      const w = Number(formData.weight) || 70;
      const h = Number(formData.height) || 175;
      const age = Number(formData.age) || 18;
      const g = formData.gender || 'male';
      const act = formData.activityLevel || 'moderate';

      const { rawBmr, rawTdee } = metabolismForForm({ gender: g, age, weight: w, height: h, activityLevel: act });

      document.querySelectorAll('.weekly-gain-rates-grid .rate-card').forEach(rc => {
        const rateVal = parseFloat(rc.dataset.rate);
        if (!isNaN(rateVal)) {
          const opt = calculateWeightGainOption({
            currentWeightKg: w,
            maintenanceCalories: rawTdee,
            weeklyRate: rateVal,
            sex: g,
            age,
            targetWeightKg: formData.targetWeight
          });
          const kgEl = rc.querySelector('.rate-card-kg');
          if (kgEl) kgEl.textContent = opt.weeklyGainKgRounded.toFixed(2);
          const calEl = rc.querySelector('.rate-card-calories');
          if (calEl) calEl.innerHTML = `${opt.targetCaloriesRounded.toLocaleString('en-US')} <span style="font-size: 0.72rem; font-weight: 600; color: #B8C0BC;">سعرة / يوم</span>`;
          const surEl = rc.querySelector('.rate-card-surplus');
          if (surEl) surEl.textContent = `فائض يومي: +${opt.dailySurplusRounded} سعرة`;
        }
      });
    };

    const showExtremeModal = () => {
      if (!extremeModal) return;
      const w = Number(formData.weight) || 70;
      const h = Number(formData.height) || 175;
      const age = Number(formData.age) || 18;
      const g = formData.gender || 'male';
      const act = formData.activityLevel || 'moderate';

      const { rawBmr, rawTdee } = metabolismForForm({ gender: g, age, weight: w, height: h, activityLevel: act });
      const plan = calculateWeightGainOption({
        currentWeightKg: w,
        maintenanceCalories: rawTdee,
        weeklyRate: 0.02,
        sex: g,
        age,
        targetWeightKg: formData.targetWeight || (w + 5)
      });

      const statsDiv = document.getElementById('extreme-gain-modal-stats');
      if (statsDiv) {
        statsDiv.innerHTML = `
          <div style="display: flex; justify-content: space-between; margin-bottom: 6px; color: #E5E7EB;">
            <span>الزيادة الأسبوعية المقدرة:</span>
            <strong style="color: #FBBF24;">+${plan.weeklyGainKgRounded.toFixed(2)} كغ / أسبوع</strong>
          </div>
          <div style="display: flex; justify-content: space-between; margin-bottom: 6px; color: #E5E7EB;">
            <span>الفائض اليومي المطلوب:</span>
            <strong style="color: #FBBF24;">+${plan.dailySurplusRounded} سعرة</strong>
          </div>
          <div style="display: flex; justify-content: space-between; color: #E5E7EB;">
            <span>سعراتك اليومية الناتجة:</span>
            <strong style="color: #FBBF24;">${plan.targetCaloriesRounded.toLocaleString('en-US')} سعرة / يوم</strong>
          </div>
        `;
      }

      if (extremeCheckbox) {
        extremeCheckbox.checked = extremeGainConfirmed;
      }
      if (extremeAcceptBtn) {
        extremeAcceptBtn.disabled = !extremeGainConfirmed;
        extremeAcceptBtn.style.opacity = extremeGainConfirmed ? '1' : '0.5';
        extremeAcceptBtn.style.cursor = extremeGainConfirmed ? 'pointer' : 'not-allowed';
      }

      extremeModal.style.display = 'flex';
    };

    const hideExtremeModal = () => {
      if (extremeModal) extremeModal.style.display = 'none';
    };

    // تفاعل بطاقات المعدلات الستة لزيادة الوزن
    document.querySelectorAll('.weekly-gain-rates-grid .rate-card').forEach(rc => {
      const handleSelect = () => {
        if (rc.classList.contains('disabled') || rc.dataset.disabled === 'true') {
          notificationService.showToast('هذا الخيار غير متاح لمن هم دون 18 عاماً للحفاظ على النمو الصحي ', 'warning');
          return;
        }

        const rateVal = parseFloat(rc.dataset.rate);
        formData.weeklyGainPercent = rateVal;
        formData.selectedWeeklyGainRate = rateVal;
        formData.selectedWeeklyGainPercent = rateVal;

        const w = Number(formData.weight) || 70;
        const h = Number(formData.height) || 175;
        const age = Number(formData.age) || 18;
        const g = formData.gender || 'male';
        const act = formData.activityLevel || 'moderate';
        const { rawBmr, rawTdee } = metabolismForForm({ gender: g, age, weight: w, height: h, activityLevel: act });
        const opt = calculateWeightGainOption({
          currentWeightKg: w,
          maintenanceCalories: rawTdee,
          weeklyRate: rateVal,
          sex: g,
          age,
          targetWeightKg: formData.targetWeight || (w + 5)
        });

        formData.bmr = Math.round(rawBmr);
        formData.rawBmr = rawBmr;
        formData.maintenanceCalories = Math.round(rawTdee);
        formData.rawMaintenanceCalories = rawTdee;
        formData.selectedWeeklyGainKg = opt.weeklyGainKgRounded;
        formData.weeklyGainKg = opt.weeklyGainKgRounded;
        formData.weeklyCalorieSurplus = opt.weeklySurplusRounded;
        formData.dailyCalorieSurplus = opt.dailySurplusRounded;
        formData.requestedTargetCalories = opt.targetCaloriesRounded;
        formData.requestedCalories = opt.targetCaloriesRounded;
        formData.targetCalories = opt.targetCaloriesRounded;
        formData.estimatedGoalWeeks = opt.estimatedWeeks;
        formData.weightGainRiskLevel = opt.safety.safetyLevel;
        formData.calorieSafetyLevel = opt.safety.safetyLevel;
        formData.calorieWarningCodes = opt.safety.warningCodes;

        document.querySelectorAll('.weekly-gain-rates-grid .rate-card').forEach(c => {
          c.classList.remove('active-rate');
          c.setAttribute('aria-checked', 'false');
          c.querySelector('.rate-card-check')?.remove();
        });

        rc.classList.add('active-rate');
        rc.setAttribute('aria-checked', 'true');
        const check = document.createElement('div');
        check.className = 'rate-card-check';
        check.textContent = '✓';
        rc.appendChild(check);

        if (rateVal >= 0.02) {
          showExtremeModal();
        } else {
          extremeGainConfirmed = false;
        }

        updateWeightGainSummary();
      };

      rc.addEventListener('click', handleSelect);
      rc.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleSelect();
        }
      });
    });

    // أحداث المودال
    extremeCheckbox?.addEventListener('change', (e) => {
      if (extremeAcceptBtn) {
        extremeAcceptBtn.disabled = !e.target.checked;
        extremeAcceptBtn.style.opacity = e.target.checked ? '1' : '0.5';
        extremeAcceptBtn.style.cursor = e.target.checked ? 'pointer' : 'not-allowed';
      }
    });

    extremeAcceptBtn?.addEventListener('click', () => {
      extremeGainConfirmed = true;
      hideExtremeModal();
      notificationService.showToast('تم تأكيد اختيار معدل التضخيم الأقصى ', 'info');
    });

    extremeCancelBtn?.addEventListener('click', () => {
      hideExtremeModal();
      formData.weeklyGainPercent = 0.0050;
      formData.selectedWeeklyGainRate = 0.0050;
      extremeGainConfirmed = false;

      const w = Number(formData.weight) || 70;
      const h = Number(formData.height) || 175;
      const age = Number(formData.age) || 18;
      const g = formData.gender || 'male';
      const act = formData.activityLevel || 'moderate';
      const { rawBmr, rawTdee } = metabolismForForm({ gender: g, age, weight: w, height: h, activityLevel: act });
      const opt = calculateWeightGainOption({
        currentWeightKg: w,
        maintenanceCalories: rawTdee,
        weeklyRate: 0.0050,
        sex: g,
        age,
        targetWeightKg: formData.targetWeight || (w + 5)
      });
      formData.bmr = Math.round(rawBmr);
      formData.rawBmr = rawBmr;
      formData.maintenanceCalories = Math.round(rawTdee);
      formData.rawMaintenanceCalories = rawTdee;
      formData.selectedWeeklyGainKg = opt.weeklyGainKgRounded;
      formData.weeklyGainKg = opt.weeklyGainKgRounded;
      formData.weeklyCalorieSurplus = opt.weeklySurplusRounded;
      formData.dailyCalorieSurplus = opt.dailySurplusRounded;
      formData.requestedTargetCalories = opt.targetCaloriesRounded;
      formData.requestedCalories = opt.targetCaloriesRounded;
      formData.targetCalories = opt.targetCaloriesRounded;
      formData.estimatedGoalWeeks = opt.estimatedWeeks;
      formData.weightGainRiskLevel = opt.safety.safetyLevel;
      formData.calorieSafetyLevel = opt.safety.safetyLevel;
      formData.calorieWarningCodes = opt.safety.warningCodes;

      document.querySelectorAll('.weekly-gain-rates-grid .rate-card').forEach(c => {
        const isRec = Math.abs(parseFloat(c.dataset.rate) - 0.0050) < 0.0001;
        c.classList.toggle('active-rate', isRec);
        c.setAttribute('aria-checked', String(isRec));
        c.querySelector('.rate-card-check')?.remove();
        if (isRec) {
          const check = document.createElement('div');
          check.className = 'rate-card-check';
          check.textContent = '✓';
          c.appendChild(check);
        }
      });
      updateWeightGainSummary();
    });
  }

  function initSupplementsStepEvents() {
    const box = document.getElementById('box-selected-supplements');
    const pills = document.getElementById('pills-selected-supplements');
    const input = document.getElementById('q-supplements-input');
    const dropdown = document.getElementById('dropdown-supplements');
    const chips = document.getElementById('supplement-rec-chips');
    const badge = document.querySelector('.supplements-count-badge');
    if (!box || !pills || !input || !dropdown) return;

    if (!Array.isArray(formData.supplements)) formData.supplements = [];
    let highlightedIndex = -1;

    const closeDropdown = () => {
      dropdown.replaceChildren();
      dropdown.style.display = 'none';
      highlightedIndex = -1;
    };

    const supplementByName = name => SUPPLEMENT_DB.find(item => item.name === name);

    const renderSelected = () => {
      pills.replaceChildren();
      for (const name of formData.supplements) {
        const supplement = supplementByName(name);
        if (!supplement) continue;
        const pill = document.createElement('span');
        pill.className = 'food-tag-pill';
        const label = document.createElement('span');
        label.textContent = supplement.nameAr || supplement.name;
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'food-tag-remove';
        remove.title = 'حذف';
        remove.setAttribute('aria-label', `حذف ${label.textContent}`);
        remove.textContent = '×';
        remove.onclick = () => {
          formData.supplements = formData.supplements.filter(item => item !== name);
          renderSelected();
        };
        pill.append(label, remove);
        pills.append(pill);
      }

      if (badge) badge.textContent = formData.supplements.length ? `${formData.supplements.length} مكمل مختار` : '';
      input.placeholder = formData.supplements.length ? '+ أضف مكملًا آخر...' : 'اكتب أول حرف للبحث وإضافة المكمل...';
      chips?.querySelectorAll('.supplement-rec-chip').forEach(chip => {
        const selected = formData.supplements.includes(chip.dataset.supplement);
        chip.classList.toggle('selected', selected);
        chip.setAttribute('aria-pressed', String(selected));
        const status = chip.querySelector('.chip-status');
        if (status) status.textContent = selected ? '✓' : '+';
      });
    };

    const addSupplement = name => {
      if (!supplementByName(name) || formData.supplements.includes(name)) return;
      formData.supplements.push(name);
      input.value = '';
      closeDropdown();
      renderSelected();
      input.focus();
    };

    const showResults = results => {
      dropdown.replaceChildren();
      highlightedIndex = -1;
      for (const supplement of results.filter(item => !formData.supplements.includes(item.name))) {
        const option = document.createElement('button');
        option.type = 'button';
        option.className = 'food-autocomplete-item';
        option.innerHTML = `<span><strong></strong><small style="display:block;color:#8C9992;margin-top:3px;"></small></span>`;
        option.querySelector('strong').textContent = `${supplement.nameAr} — ${supplement.name}`;
        option.querySelector('small').textContent = `${supplement.dose} · ${supplement.note}`;
        option.onmousedown = event => {
          event.preventDefault();
          addSupplement(supplement.name);
        };
        dropdown.append(option);
      }
      dropdown.style.display = dropdown.children.length ? 'block' : 'none';
    };

    input.addEventListener('input', () => {
      const query = input.value.trim();
      if (!query) return closeDropdown();
      showResults(searchSupplementsDb(query));
    });
    input.addEventListener('keydown', event => {
      const options = [...dropdown.querySelectorAll('.food-autocomplete-item')];
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        if (!options.length) return;
        highlightedIndex = event.key === 'ArrowDown'
          ? (highlightedIndex + 1) % options.length
          : (highlightedIndex - 1 + options.length) % options.length;
        options.forEach((option, index) => option.classList.toggle('highlighted', index === highlightedIndex));
      } else if (event.key === 'Enter' && highlightedIndex >= 0) {
        event.preventDefault();
        options[highlightedIndex]?.dispatchEvent(new MouseEvent('mousedown', { bubbles: true }));
      } else if (event.key === 'Escape') {
        closeDropdown();
      }
    });
    chips?.querySelectorAll('.supplement-rec-chip').forEach(chip => {
      chip.onclick = () => {
        const name = chip.dataset.supplement;
        if (formData.supplements.includes(name)) {
          formData.supplements = formData.supplements.filter(item => item !== name);
          renderSelected();
        } else {
          addSupplement(name);
        }
      };
    });
    document.addEventListener('click', event => {
      if (!box.contains(event.target)) closeDropdown();
    }, { once: true });
    renderSelected();
  }

  function initNutritionStepEvents() {
    function setupFoodAutocomplete(type) {
      const isLiked = type === 'liked';
      const listKey = isLiked ? 'likedFoods' : 'dislikedFoods';
      const box = document.getElementById(`box-${type}-foods`);
      const pillsContainer = document.getElementById(`pills-${type}-foods`);
      const input = document.getElementById(`q-${type}-foods-input`);
      const dropdown = document.getElementById(`dropdown-${type}-foods`);

      if (!box || !pillsContainer || !input || !dropdown) return;

      let highlightedIndex = -1;

      const updateChipStates = () => {
        const chipsContainer = document.getElementById(`${type}-food-rec-chips`);
        if (chipsContainer) {
          chipsContainer.querySelectorAll('.food-rec-chip').forEach(chip => {
            const food = chip.dataset.food;
            const isSelected = formData[listKey].includes(food);
            chip.classList.toggle('selected', isSelected);
            const statusSpan = chip.querySelector('.chip-status');
            if (statusSpan) {
              statusSpan.textContent = isSelected ? '✓' : '+';
            }
          });
        }
        const badge = document.querySelector(`.${type}-foods-count-badge`);
        if (badge) {
          if (formData[listKey].length) {
            badge.textContent = `${formData[listKey].length} ${isLiked ? 'صنف مختار' : 'مستبعد'}`;
          } else {
            badge.textContent = '';
          }
        }
      };

      const renderPills = () => {
        pillsContainer.innerHTML = formData[listKey].map(food => `
          <span class="food-tag-pill ${isLiked ? '' : 'disliked-pill'}" data-food="${food}">
            <span>${food}</span>
            <span class="food-tag-remove" data-type="${type}" data-food="${food}" title="حذف">×</span>
          </span>
        `).join('');

        input.placeholder = formData[listKey].length 
          ? '+ أضف أكلة أخرى...' 
          : 'اكتب أول حرف للبحث وإضافة الأكلة...';

        updateChipStates();
      };

      const addFood = (foodName) => {
        if (!foodName) return;
        const cleanName = foodName.trim();
        if (!cleanName) return;
        if (!formData[listKey].includes(cleanName)) {
          formData[listKey].push(cleanName);
          renderPills();
        }
        input.value = '';
        closeDropdown();
        input.focus();
      };

      const removeFood = (foodName) => {
        formData[listKey] = formData[listKey].filter(f => f !== foodName);
        renderPills();
      };

      const closeDropdown = () => {
        dropdown.style.display = 'none';
        dropdown.innerHTML = '';
        highlightedIndex = -1;
      };

      const renderDropdown = (items, query) => {
        if (!items.length && !query) {
          closeDropdown();
          return;
        }

        highlightedIndex = -1;

        let html = items.map((item, idx) => `
          <div class="food-autocomplete-item" data-index="${idx}" data-name="${item}">
            <span style="display: inline-flex; align-items: center; gap: 8px;">
              <span style="font-size: 0.95rem;">${isLiked ? '' : ''}</span>
              <span>${item}</span>
            </span>
          </div>
        `).join('');

        // إذا كان هناك نص مكتوب وغير مطابق تماماً لأحد العناصر، إتاحة إضافته كأكلة مخصصة
        const exactMatch = items.some(it => it.toLowerCase() === query.toLowerCase());
        if (query && !exactMatch) {
          html += `
            <div class="food-autocomplete-item custom-food" data-custom="true" data-name="${query}">
              <span style="display: inline-flex; align-items: center; gap: 8px;">
                <span></span>
                <span>إضافة "<strong>${query}</strong>" كأكلة مخصصة</span>
              </span>
            </div>
          `;
        }

        dropdown.innerHTML = html;
        dropdown.style.display = 'block';

        dropdown.querySelectorAll('.food-autocomplete-item').forEach(el => {
          el.addEventListener('mousedown', (e) => {
            e.preventDefault();
            const foodName = el.dataset.name;
            addFood(foodName);
          });
        });
      };

      // رصد الكتابة: البحث التفاعلي في قاعدة بيانات الأطعمة بمجرد كتابة الحرف الأول
      input.addEventListener('input', (e) => {
        const query = e.target.value.trim();
        if (!query) {
          closeDropdown();
          return;
        }

        const results = searchFoods(query, 16);
        const uniqueNames = [];
        const seen = new Set(formData[listKey]);

        for (const item of results) {
          const name = (item.nameAr || item.name || '').trim();
          if (name && !seen.has(name)) {
            seen.add(name);
            uniqueNames.push(name);
          }
        }

        renderDropdown(uniqueNames, query);
      });

      // التنقل بالأسهم واختيار الأكلة بـ Enter أو الفاصلة
      input.addEventListener('keydown', (e) => {
        const items = dropdown.querySelectorAll('.food-autocomplete-item');

        if (e.key === 'ArrowDown') {
          e.preventDefault();
          if (items.length > 0) {
            highlightedIndex = (highlightedIndex + 1) % items.length;
            updateHighlight(items);
          }
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          if (items.length > 0) {
            highlightedIndex = (highlightedIndex - 1 + items.length) % items.length;
            updateHighlight(items);
          }
        } else if (e.key === 'Enter') {
          e.preventDefault();
          if (highlightedIndex >= 0 && items[highlightedIndex]) {
            const foodName = items[highlightedIndex].dataset.name;
            addFood(foodName);
          } else if (input.value.trim()) {
            addFood(input.value.trim());
          }
        } else if (e.key === ',' || e.key === '،') {
          e.preventDefault();
          if (input.value.trim()) {
            addFood(input.value.trim());
          }
        } else if (e.key === 'Backspace' && !input.value && formData[listKey].length > 0) {
          const lastItem = formData[listKey][formData[listKey].length - 1];
          removeFood(lastItem);
        } else if (e.key === 'Escape') {
          closeDropdown();
        }
      });

      const updateHighlight = (items) => {
        items.forEach((it, idx) => {
          it.classList.toggle('highlighted', idx === highlightedIndex);
          if (idx === highlightedIndex) {
            it.scrollIntoView({ block: 'nearest' });
          }
        });
      };

      // حذف الأكلة عند النقر على علامة ×
      pillsContainer.addEventListener('click', (e) => {
        const removeBtn = e.target.closest('.food-tag-remove');
        if (removeBtn) {
          e.stopPropagation();
          const foodName = removeBtn.dataset.food;
          removeFood(foodName);
        }
      });

      // التفاعل مع رقاقات الأطعمة المقترحة
      const chipsContainer = document.getElementById(`${type}-food-rec-chips`);
      chipsContainer?.addEventListener('click', (e) => {
        const chip = e.target.closest('.food-rec-chip');
        if (!chip) return;
        const food = chip.dataset.food;
        if (!food) return;
        if (formData[listKey].includes(food)) {
          removeFood(food);
        } else {
          addFood(food);
        }
      });

      // تبويبات التصنيفات في قسم الأطعمة المفضلة
      if (isLiked) {
        const catTabsContainer = document.querySelector('.food-rec-category-tabs[data-type="liked"]');
        catTabsContainer?.querySelectorAll('.rec-cat-tab').forEach(tab => {
          tab.addEventListener('click', () => {
            catTabsContainer.querySelectorAll('.rec-cat-tab').forEach(t => t.classList.remove('active'));
            tab.classList.add('active');
            const cat = tab.dataset.cat;
            const chips = chipsContainer?.querySelectorAll('.food-rec-chip');
            chips?.forEach(chip => {
              if (cat === 'produce') {
                chip.style.display = (chip.dataset.category === 'veggies' || chip.dataset.category === 'fruits') ? 'inline-flex' : 'none';
              } else {
                chip.style.display = chip.dataset.category === cat ? 'inline-flex' : 'none';
              }
            });
          });
        });

        // ضبط الفلتر الافتراضي عند التحميل (بروتينات أولاً)
        const chips = chipsContainer?.querySelectorAll('.food-rec-chip');
        chips?.forEach(chip => {
          chip.style.display = chip.dataset.category === 'protein' ? 'inline-flex' : 'none';
        });
      }

      updateChipStates();

      // النقر داخل الصندوق يوجه التركيز لحقل الكتابة
      box.addEventListener('click', (e) => {
        if (!e.target.closest('.food-tag-remove') && !e.target.closest('.food-autocomplete-dropdown')) {
          input.focus();
        }
      });

      // إغلاق القائمة عند النقر في الخارج
      document.addEventListener('click', (e) => {
        if (!box.contains(e.target)) {
          closeDropdown();
        }
      });
    }

    setupFoodAutocomplete('liked');
    setupFoodAutocomplete('disliked');
  }

  function initPlanPreferencesStepEvents() {
    // 2. Meal slots buttons
    document.querySelectorAll('.q-mealslots-btn').forEach(btn => {
      btn.onclick = (e) => {
        e.preventDefault();
        const val = btn.dataset.val;
        formData.nutritionPlanPreferences.mealSlots = val;
        document.querySelectorAll('.q-mealslots-btn').forEach(b => {
          const isAct = b.dataset.val === val;
          b.classList.toggle('active', isAct);
          b.style.borderColor = isAct ? '#55F7A5' : 'rgba(85,247,165,0.2)';
          b.style.background = isAct ? 'rgba(85,247,165,0.15)' : 'rgba(255,255,255,0.02)';
          const check = b.querySelector('span');
          if (check) check.style.color = isAct ? '#55F7A5' : 'transparent';
        });
      };
    });

    // 3. Off-plan chips
    document.querySelectorAll('.q-offplan-chip').forEach(btn => {
      btn.onclick = (e) => {
        e.preventDefault();
        const count = Number(btn.dataset.val) || 0;
        formData.nutritionPlanPreferences.offPlanMealsCount = count;
        document.querySelectorAll('.q-offplan-chip').forEach(b => {
          const isAct = Number(b.dataset.val) === count;
          b.classList.toggle('active', isAct);
          b.style.borderColor = isAct ? '#55F7A5' : 'rgba(85,247,165,0.2)';
          b.style.background = isAct ? 'rgba(85,247,165,0.2)' : 'rgba(255,255,255,0.02)';
          b.style.color = isAct ? '#55F7A5' : '#fff';
        });
        const badge = document.getElementById('offplan-count-badge');
        if (badge) {
          badge.textContent = `${count} ${count === 0 ? '(بدون وجبات مفتوحة)' : 'وجبة أسبوعياً'}`;
        }
      };
    });

    // 4. Sweets toggle & search
    const toggleNo = document.getElementById('q-sweets-toggle-no');
    const toggleYes = document.getElementById('q-sweets-toggle-yes');
    const detailsPanel = document.getElementById('q-sweets-details-panel');

    if (toggleNo && toggleYes) {
      toggleNo.onclick = (e) => {
        e.preventDefault();
        formData.nutritionPlanPreferences.sweets.enabled = false;
        toggleNo.classList.add('active');
        toggleNo.style.borderColor = '#55F7A5';
        toggleNo.style.background = 'rgba(85,247,165,0.15)';
        toggleYes.classList.remove('active');
        toggleYes.style.borderColor = 'rgba(85,247,165,0.2)';
        toggleYes.style.background = 'transparent';
        if (detailsPanel) detailsPanel.style.display = 'none';
      };
      toggleYes.onclick = (e) => {
        e.preventDefault();
        formData.nutritionPlanPreferences.sweets.enabled = true;
        toggleYes.classList.add('active');
        toggleYes.style.borderColor = '#55F7A5';
        toggleYes.style.background = 'rgba(85,247,165,0.15)';
        toggleNo.classList.remove('active');
        toggleNo.style.borderColor = 'rgba(85,247,165,0.2)';
        toggleNo.style.background = 'transparent';
        if (detailsPanel) detailsPanel.style.display = 'block';
      };
    }

    const sweetsInput = document.getElementById('q-sweets-search-input');
    const sweetsDropdown = document.getElementById('q-sweets-dropdown');
    if (sweetsInput && sweetsDropdown) {
      sweetsInput.addEventListener('input', () => {
        const q = sweetsInput.value.trim();
        if (!q) {
          sweetsDropdown.style.display = 'none';
          return;
        }
        const results = searchFoods(q, 10);
        if (results.length === 0) {
          sweetsDropdown.innerHTML = `<div style="padding: 10px; color: #8C9992; font-size: 0.85rem; text-align: center;">لم يتم العثور على أطعمة مطابقة</div>`;
          sweetsDropdown.style.display = 'block';
          return;
        }
        sweetsDropdown.innerHTML = results.map(item => `
          <div class="food-autocomplete-item" data-id="${item.id}" style="padding: 8px 12px; cursor: pointer; border-bottom: 1px solid rgba(85,247,165,0.1); display: flex; justify-content: space-between; align-items: center;">
            <span style="color: #fff; font-size: 0.88rem;">${item.nameAr || item.name}</span>
            <span style="color: #55F7A5; font-size: 0.78rem; font-family: monospace;">${item.caloriesPer100g || item.calories || 300} سعرة/100غ</span>
          </div>
        `).join('');
        sweetsDropdown.style.display = 'block';

        sweetsDropdown.querySelectorAll('.food-autocomplete-item').forEach(div => {
          div.onclick = () => {
            const id = div.dataset.id;
            const selectedFood = results.find(f => f.id === id);
            if (selectedFood) {
              formData.nutritionPlanPreferences.sweets.item = selectedFood;
              sweetsInput.value = selectedFood.nameAr || selectedFood.name;
              sweetsDropdown.style.display = 'none';
              let badge = document.getElementById('q-sweets-selected-badge');
              if (!badge) {
                badge = document.createElement('div');
                badge.id = 'q-sweets-selected-badge';
                badge.style.marginTop = '6px';
                badge.style.display = 'inline-flex';
                badge.style.alignItems = 'center';
                badge.style.gap = '6px';
                badge.style.padding = '4px 10px';
                badge.style.borderRadius = '8px';
                badge.style.background = 'rgba(85,247,165,0.12)';
                badge.style.border = '1px solid #55F7A5';
                badge.style.color = '#55F7A5';
                badge.style.fontSize = '0.82rem';
                badge.style.fontWeight = '700';
                sweetsInput.parentElement.parentElement.appendChild(badge);
              }
              badge.textContent = `✓ تم اختيار: ${selectedFood.nameAr || selectedFood.name} (~${selectedFood.caloriesPer100g || selectedFood.calories || 300} سعرة/100غ)`;
            }
          };
        });
      });

      document.addEventListener('click', (e) => {
        if (!sweetsInput.contains(e.target) && !sweetsDropdown.contains(e.target)) {
          sweetsDropdown.style.display = 'none';
        }
      });
    }

    const portionEl = document.getElementById('q-sweets-portion');
    if (portionEl) {
      portionEl.onchange = () => {
        formData.nutritionPlanPreferences.sweets.portion = Math.max(5, Number(portionEl.value) || 50);
      };
    }
    const freqEl = document.getElementById('q-sweets-frequency');
    if (freqEl) {
      freqEl.onchange = () => {
        formData.nutritionPlanPreferences.sweets.servingsPerWeek = Number(freqEl.value) || 1;
      };
    }

    // 5. Diet style buttons
    document.querySelectorAll('.q-dietstyle-btn').forEach(btn => {
      btn.onclick = (e) => {
        e.preventDefault();
        const val = btn.dataset.val;
        formData.nutritionPlanPreferences.dietStyle = val;
        document.querySelectorAll('.q-dietstyle-btn').forEach(b => {
          const isAct = b.dataset.val === val;
          b.classList.toggle('active', isAct);
          b.style.borderColor = isAct ? '#55F7A5' : 'rgba(85,247,165,0.2)';
          b.style.background = isAct ? 'rgba(85,247,165,0.15)' : 'rgba(255,255,255,0.02)';
          const label = b.querySelector('div:nth-child(2)');
          if (label) label.style.color = isAct ? '#55F7A5' : '#fff';
        });
      };
    });

    // 6. Plan format buttons
    document.querySelectorAll('.q-planformat-btn').forEach(btn => {
      btn.onclick = (e) => {
        e.preventDefault();
        const val = btn.dataset.val;
        formData.nutritionPlanPreferences.planFormat = val;
        document.querySelectorAll('.q-planformat-btn').forEach(b => {
          const isAct = b.dataset.val === val;
          b.classList.toggle('active', isAct);
          b.style.borderColor = isAct ? '#55F7A5' : 'rgba(85,247,165,0.2)';
          b.style.background = isAct ? 'rgba(85,247,165,0.15)' : 'rgba(255,255,255,0.02)';
          const label = b.querySelector('div:nth-child(2)');
          if (label) label.style.color = isAct ? '#55F7A5' : '#fff';
        });
      };
    });
  }

  function collectInjuryDetailsFromDom() {
    const next = { ...(formData.injuryDetails || {}) };
    document.querySelectorAll('[data-injury-region]').forEach(section => {
      const region = section.dataset.injuryRegion;
      const value = field => section.querySelector(`[data-injury-field="${field}"]`);
      next[region] = {
        status: value('status')?.value?.trim() || '',
        side: value('side')?.value || 'unspecified',
        painSeverity: Math.min(10, Math.max(0, Number(value('painSeverity')?.value) || 0)),
        medicalBan: value('medicalBan')?.value || 'none',
        triggerMovements: value('triggerMovements')?.value?.trim() || '',
        clinicianInstructions: value('clinicianInstructions')?.value?.trim() || '',
        worsening: Boolean(value('worsening')?.checked),
        recentUnevaluated: Boolean(value('recentUnevaluated')?.checked)
      };
    });
    formData.injuryDetails = next;
  }

  function initHealthStepEvents() {
    document.querySelectorAll('input[name="q-injuries"]').forEach(input => {
      input.addEventListener('change', () => {
        collectInjuryDetailsFromDom();
        const all = [...document.querySelectorAll('input[name="q-injuries"]')];
        if (input.value === 'none' && input.checked) {
          all.filter(item => item.value !== 'none').forEach(item => { item.checked = false; });
        } else if (input.checked) {
          const none = all.find(item => item.value === 'none');
          if (none) none.checked = false;
        }
        const selected = all.filter(item => item.checked && item.value !== 'none').map(item => item.value);
        formData.injuries = selected;
        const details = document.getElementById('q-injury-details');
        if (details) details.innerHTML = renderInjuryDetailFields();
      });
    });
  }

  function initBodyFatStepEvents() {
    const choices = Array.from(document.querySelectorAll('[data-body-fat-range]'));
    // Prioritize nearby photos on mobile and keep offscreen 1.8 MB images
    // from competing for bandwidth until they are actually needed.
    stopBodyFatPhotoLoading = startBodyFatImageLoader(document.querySelector('.body-fat-step'));
    choices.forEach(choice => choice.addEventListener('click', () => {
      const selected = getBodyFatRange(choice.dataset.bodyFatRange, formData.gender);
      if (!selected) return;
      formData.bodyFatRange = selected.label;
      formData.bodyFatPercent = selected.estimate;
      choices.forEach(other => {
        const chosen = other === choice;
        other.classList.toggle('is-selected', chosen);
        other.setAttribute('aria-checked', String(chosen));

      });
    }));
  }

  function saveCurrentStepInputs() {
    const activeSteps = getActiveSteps();
    const currentStepKey = activeSteps[currentStep - 1] || activeSteps[0];

    if (METABOLIC_STEP_KEYS.includes(currentStepKey)) {
      const root = document.getElementById('metabolic-onboarding');
      if (root) Object.assign(formData, collectMetabolicAnswers(root, formData, localDate()));
    } else if (currentStepKey === STEP_KEYS.MEASUREMENTS) {
      const name = document.getElementById('q-name')?.value;
      const age = Number(document.getElementById('q-age')?.value) || formData.age;
      const gender = document.getElementById('q-gender')?.value || formData.gender;
      const height = Number(document.getElementById('q-height')?.value) || formData.height;
      const weight = Number(document.getElementById('q-weight')?.value) || formData.weight;
      if (name && name.trim()) formData.name = name.trim();
      if (age >= 10 && age <= 90) formData.age = age;
      if (gender) formData.gender = gender;
      if (height > 0) formData.height = height;
      if (weight > 0) formData.weight = weight;
    } else if (currentStepKey === STEP_KEYS.BODY_FAT) {
      const selected = document.querySelector('[data-body-fat-range][aria-checked="true"]');
      const option = getBodyFatRange(selected?.dataset.bodyFatRange, formData.gender);
      if (option) {
        formData.bodyFatRange = option.label;
        formData.bodyFatPercent = option.estimate;
      }
    } else if (currentStepKey === STEP_KEYS.GOAL) {
      const targetWeight = Number(document.getElementById('q-target-weight')?.value);
      if (targetWeight > 0) formData.targetWeight = targetWeight;
    } else if (currentStepKey === STEP_KEYS.WEEKLY_LOSS_RATE) {
      const w = Number(formData.weight) || 70;
      const h = Number(formData.height) || 175;
      const age = Number(formData.age) || 18;
      const g = formData.gender || 'male';
      const act = formData.activityLevel || 'moderate';
      const { rawBmr: bmr, rawTdee: tdee } = metabolismForForm({ gender: g, age, weight: w, height: h, activityLevel: act });
      const option = calculateWeightLossOption({
        currentWeightKg: w,
        maintenanceCalories: tdee,
        weeklyRate: formData.weeklyLossPercent || 0.0075,
        sex: g,
        age,
        targetWeightKg: formData.targetWeight || (w - 5)
      });
      formData.bmr = Math.round(bmr);
      formData.rawBmr = bmr;
      formData.maintenanceCalories = Math.round(tdee);
      formData.rawMaintenanceCalories = tdee;
      formData.selectedWeeklyLossRate = option.rate;
      formData.selectedWeeklyLossPercent = option.rate;
      formData.weeklyLossPercent = option.rate;
      formData.selectedWeeklyLossKg = option.weeklyLossKgRounded;
      formData.weeklyLossKg = option.weeklyLossKgRounded;
      formData.weeklyCalorieDeficit = option.weeklyDeficitRounded;
      formData.dailyCalorieDeficit = option.dailyDeficitRounded;
      formData.requestedTargetCalories = option.targetCaloriesRounded;
      formData.requestedCalories = option.targetCaloriesRounded;
      formData.estimatedGoalWeeks = option.estimatedWeeks;
      formData.weightLossRiskLevel = option.safety.safetyLevel;
      formData.calorieSafetyLevel = option.safety.safetyLevel;
      formData.calorieWarningCodes = option.safety.warningCodes;
    } else if (currentStepKey === STEP_KEYS.WEEKLY_GAIN_RATE) {
      const w = Number(formData.weight) || 70;
      const h = Number(formData.height) || 175;
      const age = Number(formData.age) || 18;
      const g = formData.gender || 'male';
      const act = formData.activityLevel || 'moderate';
      const { rawBmr: bmr, rawTdee: tdee } = metabolismForForm({ gender: g, age, weight: w, height: h, activityLevel: act });
      const option = calculateWeightGainOption({
        currentWeightKg: w,
        maintenanceCalories: tdee,
        weeklyRate: formData.weeklyGainPercent || 0.0050,
        sex: g,
        age,
        targetWeightKg: formData.targetWeight || (w + 5)
      });
      formData.bmr = Math.round(bmr);
      formData.rawBmr = bmr;
      formData.maintenanceCalories = Math.round(tdee);
      formData.rawMaintenanceCalories = tdee;
      formData.selectedWeeklyGainRate = option.rate;
      formData.selectedWeeklyGainPercent = option.rate;
      formData.weeklyGainPercent = option.rate;
      formData.selectedWeeklyGainKg = option.weeklyGainKgRounded;
      formData.weeklyGainKg = option.weeklyGainKgRounded;
      formData.weeklyCalorieSurplus = option.weeklySurplusRounded;
      formData.dailyCalorieSurplus = option.dailySurplusRounded;
      formData.requestedTargetCalories = option.targetCaloriesRounded;
      formData.requestedCalories = option.targetCaloriesRounded;
      formData.targetCalories = option.targetCaloriesRounded;
      formData.estimatedGoalWeeks = option.estimatedWeeks;
      formData.weightGainRiskLevel = option.safety.safetyLevel;
      formData.calorieSafetyLevel = option.safety.safetyLevel;
      formData.calorieWarningCodes = option.safety.warningCodes;
    } else if (currentStepKey === STEP_KEYS.NUTRITION) {
      const likedInput = document.getElementById('q-liked-foods-input');
      if (likedInput && likedInput.value.trim()) {
        const val = likedInput.value.trim();
        if (!formData.likedFoods.includes(val)) {
          formData.likedFoods.push(val);
        }
        likedInput.value = '';
      }
      const dislikedInput = document.getElementById('q-disliked-foods-input');
      if (dislikedInput && dislikedInput.value.trim()) {
        const val = dislikedInput.value.trim();
        if (!formData.dislikedFoods.includes(val)) {
          formData.dislikedFoods.push(val);
        }
        dislikedInput.value = '';
      }
    } else if (currentStepKey === STEP_KEYS.PLAN_PREFERENCES) {
      const portionInput = document.getElementById('q-sweets-portion');
      const freqSelect = document.getElementById('q-sweets-frequency');
      if (portionInput && !isNaN(Number(portionInput.value))) {
        formData.nutritionPlanPreferences.sweets.portion = Math.max(5, Number(portionInput.value));
      }
      if (freqSelect && !isNaN(Number(freqSelect.value))) {
        formData.nutritionPlanPreferences.sweets.servingsPerWeek = Number(freqSelect.value);
      }
    } else if (currentStepKey === STEP_KEYS.HEALTH) {
      collectInjuryDetailsFromDom();
      const checkedInjuries = Array.from(document.querySelectorAll('input[name="q-injuries"]:checked')).map(el => el.value).filter(value => value !== 'none');
      formData.injuries = checkedInjuries;
    } else if (currentStepKey === STEP_KEYS.TRAINING) {
      const days = Number(document.getElementById('q-workout-days')?.value);
      const dur = Number(document.getElementById('q-session-duration')?.value);
      if (days > 0) formData.workoutDaysCount = days;
      if (dur > 0) formData.sessionDurationMin = dur;
      formData.trainingLevel = document.querySelector('input[name="q-training-level"]:checked')?.value || formData.trainingLevel;
      formData.trainingBreakMonths = Math.max(0, Number(document.getElementById('q-training-break')?.value) || 0);
      formData.availableEquipment = Array.from(document.querySelectorAll('input[name="q-available-equipment"]:checked')).map(el => el.value);
      if (formData.availableEquipment.length) formData.equipment = formData.availableEquipment.some(kind => ['machines','barbell','cables'].includes(kind)) ? 'gym' : 'home';
      formData.focusAreas = Array.from(document.querySelectorAll('input[name="q-focus-areas"]:checked')).map(el => el.value);
    }
  }

  function render() {
    const scrollToStepTop = () => {
      try {
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      } catch (_) {
        window.scrollTo(0, 0);
      }
      if (document.documentElement) document.documentElement.scrollTop = 0;
      if (document.body) document.body.scrollTop = 0;
      const container = document.getElementById('view-container');
      if (container) container.scrollTop = 0;
      const appRoot = document.getElementById('app');
      if (appRoot) appRoot.scrollTop = 0;
    };

    const container = document.querySelector('.questionnaire-container');
    if (!container) return;

    if (showWelcomeScreen) {
      container.innerHTML = renderWelcomeScreenHTML();
      bindQuestionnaireEvents();
      scrollToStepTop();
      requestAnimationFrame(scrollToStepTop);
      return;
    }

    const activeSteps = getActiveSteps();
    const totalSteps = activeSteps.length;
    if (currentStep > totalSteps) currentStep = totalSteps;
    const currentStepKey = activeSteps[currentStep - 1] || activeSteps[0];

    const area = document.getElementById('step-content-area');
    if (!area) {
      container.innerHTML = renderStepWorkflowHTML(currentStep, totalSteps, currentStepKey);
      bindQuestionnaireEvents();
      scrollToStepTop();
      requestAnimationFrame(scrollToStepTop);
      return;
    }

    // 1. تحديث نص رقم الخطوة بالأعلى ديناميكياً مع كل شاشة: "الخطوة X من Y"
    const headerStep = document.getElementById('q-step-indicator-text');
    if (headerStep) {
      headerStep.textContent = `الخطوة ${currentStep} من ${totalSteps}`;
    }

    const milestones = document.getElementById('q-milestones-container');
    if (milestones) milestones.innerHTML = renderQuestionnaireMilestones(currentStep, totalSteps);

    // 2. تحديث مؤشرات شريط التقدم
    const stepsBar = document.getElementById('q-steps-bar');
    if (stepsBar) {
      stepsBar.innerHTML = Array.from({ length: totalSteps }, (_, i) => `
        <div style="flex: 1; height: 4px; border-radius: 999px; background: ${i + 1 <= currentStep ? '#55F7A5' : 'rgba(85, 247, 165, 0.15)'}; box-shadow: ${i + 1 === currentStep ? '0 0 8px #55F7A5' : 'none'}; transition: all 0.3s ease;"></div>
      `).join('');
    }

    // 3. تحديث زر الرجوع
    const backBtn = document.getElementById('q-back-step-btn');
    if (backBtn) {
      backBtn.style.visibility = 'visible';
    }

    // 4. تحديث محتوى الخطوة
    area.innerHTML = renderStepContent(currentStepKey);

    // 5. إعادة ربط أحداث الخطوة والتمرير فورياً لأعلى الشاشة لتبدأ دائماً من فوق لتحت
    bindQuestionnaireEvents();
    scrollToStepTop();
    requestAnimationFrame(scrollToStepTop);
    setTimeout(scrollToStepTop, 15);
  }
}
